

// import React, {
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";
// import Main from "../Main";
// import {
//   createFinkedaCheckout,
//   fetchFinkedaGateways,
//   fetchFinkedaPayoutPricing,
// } from "../../api/finkedaApi";
// import { useNotify } from "../../context/NotifyContext";
// import CustomerLookup from "../../components/CustomerLookup";
// import useBankVerification from "../../hooks/useBankVerification";
// import BankVerificationBox from "../../components/BankVerificationBox";

// // TEMPORARY: Finkeda pricing breakdown for testing only.
// // Remove/comment this section before production.
// import FinkedaPricingBreakdownBox from "../../components/FinkedaPricingBreakdownBox";



// const PAN_RE = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
// const IFSC_RE = /^[A-Z]{4}0[A-Z0-9]{6}$/;

// function round2(x) {
//   return Math.round((Number(x) + Number.EPSILON) * 100) / 100;
// }

// const PgPayout = () => {
//   const { notify } = useNotify();

//   const submitLock = useRef(false);
//   const nameInputRef = useRef(null);

//   const [loading, setLoading] = useState(false);
//   const [gateways, setGateways] = useState([]);
//   const [errors, setErrors] = useState({});

//   const [pricing, setPricing] = useState(null);
//   const [pricingLoading, setPricingLoading] = useState(true);
//   const [pricingError, setPricingError] = useState("");

//   const [form, setForm] = useState({
//     amount: "",
//     settledIn: "super",
//     cardType: "CREDITCARD",
//     cardNetwork: "MASTERCARD",
//     pgType: "",
//     markup: "", // total customer markup (same as before, goes to backend)
//     binValue: "",

//     senderName: "",
//     senderAccount: "",
//     senderIfsc: "",
//     senderBank: "",
//     senderMobile: "",
//     senderPanNumber: "",
//     senderAccType: "SAVINGS",
//   });

//   // UI only: TOTAL % typed by the user (PG + customer markup + extra).
//   // Backend value is unchanged: form.markup = total - gatewayChargePercent
//   //                                        = customerMarkup + extra
//   const [totalText, setTotalText] = useState("");
//   const totalTouched = useRef(false);
//   const totalTimer = useRef(null); // 3s debounce for minimum check

//   useEffect(() => () => clearTimeout(totalTimer.current), []);

//   const [isNewCustomer, setIsNewCustomer] = useState(false);
//   const [customerSourceId, setCustomerSourceId] = useState("");

//   const bankVerification = useBankVerification({
//     accountNumber: form.senderAccount,
//     ifsc: form.senderIfsc,
//     name: form.senderName,
//     bankId: form.senderBank,
//     sourceType: "MATM",
//     sourceId: customerSourceId,
//     onVerified: (result) => {
//       if (result.beneficiaryName) {
//         setForm((current) => ({
//           ...current,
//           senderName: result.beneficiaryName,
//         }));
//       }
//     },
//   });

//   const {
//     result: currentBankVerification,
//     ready: bankVerificationReady,
//     policyLoading: bankVerificationPolicyLoading,
//   } = bankVerification;

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await fetchFinkedaGateways();

//         const list = Array.isArray(res?.data)
//           ? res.data
//           : res?.data?.gateways || [];

//         setGateways(list);

//         const firstGateway = list?.[0];
//         const firstPg = firstGateway?.pgType || firstGateway?.code || "";
//         const firstCt = firstGateway?.cardTypes?.[0] || "CREDITCARD";
//         const firstDetail =
//           firstGateway?.cardTypeDetails?.find((d) => d.cardType === firstCt) ||
//           firstGateway?.cardTypeDetails?.[0];
//         const firstNet = firstDetail?.networks?.[0] || "MASTERCARD";

//         if (firstPg) {
//           setForm((prev) => ({
//             ...prev,
//             pgType: prev.pgType || firstPg,
//             cardType: prev.cardType || firstCt,
//             cardNetwork: prev.cardNetwork || firstNet,
//           }));
//         }
//       } catch {
//         setGateways([]);
//       }
//     })();
//   }, []);

//   const selectedGateway = useMemo(() => {
//     return (
//       gateways.find(
//         (g) =>
//           (g.pgType || g.code) === form.pgType ||
//           g.code === form.pgType
//       ) ||
//       gateways[0] ||
//       null
//     );
//   }, [gateways, form.pgType]);

//   const availableCardTypes = useMemo(() => {
//     if (!selectedGateway?.cardTypes?.length) {
//       return [{ value: "CREDITCARD", label: "CREDITCARD" }];
//     }
//     return selectedGateway.cardTypes.map((ct) => ({ value: ct, label: ct }));
//   }, [selectedGateway]);

//   const selectedCardTypeDetail = useMemo(() => {
//     if (!selectedGateway?.cardTypeDetails?.length) return null;
//     return (
//       selectedGateway.cardTypeDetails.find(
//         (d) => d.cardType === form.cardType
//       ) ||
//       selectedGateway.cardTypeDetails[0] ||
//       null
//     );
//   }, [selectedGateway, form.cardType]);

//   const availableCardNetworks = useMemo(() => {
//     const list =
//       selectedCardTypeDetail?.networks ||
//       selectedGateway?.networks?.map((n) => n.networkType) || [
//         "MASTERCARD",
//         "VISACARD",
//         "RUPAYCARD",
//       ];
//     const unique = [...new Set(list.filter(Boolean))];
//     return unique.map((net) => ({ value: net, label: net }));
//   }, [selectedCardTypeDetail, selectedGateway]);

//   const amountLimits = useMemo(() => {
//     const netLimit = selectedCardTypeDetail?.networkLimits?.[form.cardNetwork];
//     const min = netLimit?.minAmount ?? selectedCardTypeDetail?.minAmount ?? 1;
//     const max = netLimit?.maxAmount ?? selectedCardTypeDetail?.maxAmount ?? 50000;
//     return { minAmount: Number(min) || 1, maxAmount: Number(max) || 50000 };
//   }, [selectedCardTypeDetail, form.cardNetwork]);

//   useEffect(() => {
//     const timer = setTimeout(async () => {
//       try {
//         setPricingLoading(true);
//         setPricingError("");

//         const res = await fetchFinkedaPayoutPricing({
//           amount: form.amount || 0,
//           pgType: form.pgType || undefined,
//           cardType: form.cardType || undefined,
//           cardNetwork: form.cardNetwork || undefined,
//         });

//         if (!res.success || !res.data) {
//           setPricing(null);
//           setPricingError(
//             res.message ||
//               "Unable to load pricing. Payout is blocked."
//           );
//           return;
//         }

//         const data = res.data;

//         if (
//           data.customerMarkup == null &&
//           data.pricing?.customerMarkup == null
//         ) {
//           setPricing(null);
//           setPricingError(
//             "Incomplete pricing received. Payout is blocked."
//           );
//           return;
//         }

//         const minMarkup = Number(
//           data.customerMarkup ?? data.pricing?.customerMarkup ?? 0
//         );
//         setPricing(data);

//         setForm((prev) => {
//           const currentMarkupNum = Number(prev.markup);
//           const needsDefault =
//             prev.markup === "" ||
//             prev.markup === "0" ||
//             !Number.isFinite(currentMarkupNum) ||
//             currentMarkupNum < minMarkup;
//           return {
//             ...prev,
//             markup: needsDefault ? String(minMarkup) : prev.markup,
//           };
//         });
//       } catch {
//         setPricing(null);
//         setPricingError(
//           "Unable to load pricing. Payout is blocked."
//         );
//       } finally {
//         setPricingLoading(false);
//       }
//     }, 250);

//     return () => clearTimeout(timer);
//   }, [form.pgType, form.cardType, form.cardNetwork, form.amount]);

//   /*
//    * UI only: pricing badalne par (pgType / cardType / network / amount)
//    * total ko sync rakhta hai aur form.markup = total - gateway set karta hai.
//    * Agar user ne total nahi chheda to total = gateway + customerMarkup (minimum).
//    */
//   useEffect(() => {
//     if (!pricing) return;
//     const gateway = Number(
//       pricing?.gatewayChargePercent ??
//         pricing?.pricing?.gatewayChargePercent ??
//         0
//     );
//     const min = Number(
//       pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//     );
//     const base = round2(gateway + min);
//     const typed = Number(totalText);

//     const total =
//       !totalTouched.current || !Number.isFinite(typed) || typed < base
//         ? base
//         : Math.min(typed, 100);

//     if (String(total) !== totalText) setTotalText(String(total));
//     setForm((prev) => ({
//       ...prev,
//       markup: String(round2(total - gateway)),
//     }));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pricing]);

//   /*
//    * Payout preview calculation:
//    * Customer Charge = (amount * actualMarkup) / 100
//    * Beneficiary Receive = amount - Customer Charge
//    * Performer Earning = Extra markup charged above minimum customer markup
//    */
//   const payoutPreview = useMemo(() => {
//     const amount = Number(form.amount) || 0;
//     const enteredMarkup = Number(form.markup) || 0;

//     const gatewayChargePercent = Number(
//       pricing?.gatewayChargePercent ??
//         pricing?.pricing?.gatewayChargePercent ??
//         0
//     );
//     const hierarchyPercent = Number(
//       pricing?.hierarchyPercent ??
//         pricing?.pricing?.hierarchyPercent ??
//         0
//     );
//     const extraMarkup = Number(
//       pricing?.extraMarkup ??
//         pricing?.pricing?.extraMarkup ??
//         0
//     );
//     const customerMarkup = Number(
//       pricing?.customerMarkup ??
//         pricing?.pricing?.customerMarkup ??
//         round2(hierarchyPercent + extraMarkup)
//     );

//     const actualMarkup = Math.max(enteredMarkup, customerMarkup);
//     const finalCustomerMarkup = actualMarkup;

//     const customerExtraPercent = round2(
//       Math.max(0, actualMarkup - customerMarkup)
//     );

//     // Charge & Markup Amounts based on backend pricing
//     const gatewayChargeAmount = round2((amount * gatewayChargePercent) / 100);
//     const hierarchyAmount = round2((amount * hierarchyPercent) / 100);
//     const extraMarkupAmount = round2((amount * extraMarkup) / 100);
//     const customerExtraAmount = round2((amount * customerExtraPercent) / 100);
//     const finalCustomerMarkupAmount = round2((amount * finalCustomerMarkup) / 100);
//     const totalCharges = round2(gatewayChargeAmount + finalCustomerMarkupAmount);
//     const totalChargesPercent = round2(gatewayChargePercent + finalCustomerMarkup);
//     const customerCharge = totalCharges;
//     const beneficiaryReceive = round2(Math.max(0, amount - totalCharges));
//     const walletEarning = customerExtraAmount;

//     return {
//       amountEntered: round2(amount),
//       customerMarkup,
//       actualMarkup,
//       gatewayChargePercent,
//       gatewayChargeAmount,
//       hierarchyPercent,
//       hierarchyAmount,
//       extraMarkup,
//       extraMarkupAmount,
//       customerExtraPercent,
//       customerExtraAmount,
//       finalCustomerMarkup,
//       finalCustomerMarkupAmount,
//       totalCharges,
//       totalChargesPercent,
//       customerCharge,
//       beneficiaryReceive,
//       walletEarning,
//       role:
//         pricing?.performerRole ||
//         pricing?.pricing?.performerRole ||
//         "retailer",
//       planCode:
//         pricing?.planCode ||
//         pricing?.pricing?.planCode ||
//         "",
//     };
//   }, [form.amount, form.markup, pricing]);

//   const pricingReady = Boolean(
//     pricing &&
//       (pricing.customerMarkup != null ||
//         pricing.pricing?.customerMarkup != null)
//   );

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (
//       [
//         "senderName",
//         "senderAccount",
//         "senderIfsc",
//         "senderBank",
//         "senderMobile",
//         "senderPanNumber",
//         "senderAccType",
//       ].includes(name)
//     ) {
//       setCustomerSourceId("");
//     }

//     let next = value;

//     if (
//       ["amount", "senderAccount", "senderMobile", "binValue"].includes(name)
//     ) {
//       next = value.replace(/\D/g, "");
//     }

//     if (name === "amount" && Number(next) > amountLimits.maxAmount) {
//       next = String(amountLimits.maxAmount);
//     }

//     if (name === "binValue") {
//       next = next.slice(0, 6);
//     }

//     if (name === "senderMobile") {
//       next = next.slice(0, 10);
//     }

//     if (name === "senderAccount") {
//       next = next.slice(0, 18);
//     }

//     if (name === "senderIfsc" || name === "senderPanNumber") {
//       next = value.toUpperCase().replace(/\s/g, "");
//     }

//     if (name === "markup") {
//       next = value.replace(/[^\d.]/g, "");

//       const parts = next.split(".");

//       if (parts.length > 2) {
//         next = `${parts[0]}.${parts.slice(1).join("")}`;
//       }

//       if (Number(next) > 100) {
//         next = "100";
//       }

//       /*
//        * Never allow markup below minimum.
//        */
//       const minMarkup = Number(
//         pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//       );
//       if (
//         next !== "" &&
//         pricing &&
//         Number.isFinite(minMarkup) &&
//         Number(next) < minMarkup
//       ) {
//         next = String(minMarkup);
//       }
//     }

//     if (name === "pgType") {
//       const g = gateways.find((item) => (item.pgType || item.code) === next);
//       const nextCardType = g?.cardTypes?.[0] || "CREDITCARD";
//       const ctDetail =
//         g?.cardTypeDetails?.find((d) => d.cardType === nextCardType) ||
//         g?.cardTypeDetails?.[0];
//       const nextNetwork = ctDetail?.networks?.[0] || "MASTERCARD";
//       setForm((prev) => ({
//         ...prev,
//         pgType: next,
//         cardType: nextCardType,
//         cardNetwork: nextNetwork,
//       }));
//       if (errors.pgType) setErrors((prev) => ({ ...prev, pgType: "" }));
//       return;
//     }

//     if (name === "cardType") {
//       const g = gateways.find(
//         (item) => (item.pgType || item.code) === form.pgType
//       );
//       const ctDetail =
//         g?.cardTypeDetails?.find((d) => d.cardType === next) ||
//         g?.cardTypeDetails?.[0];
//       const currentNetworkValid = ctDetail?.networks?.includes(form.cardNetwork);
//       const nextNetwork = currentNetworkValid
//         ? form.cardNetwork
//         : ctDetail?.networks?.[0] || "MASTERCARD";
//       setForm((prev) => ({
//         ...prev,
//         cardType: next,
//         cardNetwork: nextNetwork,
//       }));
//       if (errors.cardType) setErrors((prev) => ({ ...prev, cardType: "" }));
//       return;
//     }

//     setForm((prev) => ({
//       ...prev,
//       [name]: next,
//     }));

//     if (errors[name]) {
//       setErrors((prev) => ({
//         ...prev,
//         [name]: "",
//       }));
//     }
//   };

//   /*
//    * UI only: user TOTAL % type karta hai (e.g. 3).
//    * Total - PG charge = customer markup (customerMarkup + extra).
//    * form.markup = total - gateway  (backend ko wahi customer markup jata hai).
//    */
//   const handleTotalChange = (e) => {
//     let v = e.target.value.replace(/[^\d.]/g, "");

//     const parts = v.split(".");
//     if (parts.length > 2) v = `${parts[0]}.${parts.slice(1).join("")}`;

//     const [i, d] = v.split(".");
//     if (d !== undefined) v = `${i}.${d.slice(0, 2)}`;

//     if (Number(v) > 100) v = "100";

//     const gateway = Number(
//       pricing?.gatewayChargePercent ??
//         pricing?.pricing?.gatewayChargePercent ??
//         0
//     );
//     const min = Number(
//       pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//     );
//     const base = round2(gateway + min);

//     // Typing ke time har value allowed hai.
//     totalTouched.current = v !== "";
//     setTotalText(v);

//     // 3 second typing band hone ke baad check: kam ho to minimum dikhao,
//     // zyada ho to kuch nahi karna.
//     clearTimeout(totalTimer.current);
//     totalTimer.current = setTimeout(() => {
//       setTotalText((prev) => {
//         const n = Number(prev);
//         if (prev === "" || !Number.isFinite(n) || n < base) {
//           totalTouched.current = false;
//           return String(base);
//         }
//         return prev;
//       });
//     }, 3000);

//     const total = Math.max(Number(v) || 0, base);
//     setForm((prev) => ({
//       ...prev,
//       markup: String(round2(total - gateway)),
//     }));

//     if (errors.markup) setErrors((prev) => ({ ...prev, markup: "" }));
//   };

//   // Field se bahar jaate hi bhi same check (3s ka wait nahi).
//   const handleTotalBlur = () => {
//     const gateway = Number(
//       pricing?.gatewayChargePercent ??
//         pricing?.pricing?.gatewayChargePercent ??
//         0
//     );
//     const min = Number(
//       pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//     );
//     const base = round2(gateway + min);
//     const typed = Number(totalText);

//     clearTimeout(totalTimer.current);
//     if (totalText === "" || !Number.isFinite(typed) || typed < base) {
//       totalTouched.current = false;
//       setTotalText(String(base));
//     }
//   };

//   const validate = () => {
//     const next = {};

//     const amount = Number(form.amount);

//     if (!Number.isInteger(amount) || amount <= 0) {
//       next.amount = "Amount must be a positive whole number";
//     } else if (amount < amountLimits.minAmount) {
//       next.amount = `Minimum amount allowed is ₹${amountLimits.minAmount}`;
//     } else if (amount > amountLimits.maxAmount) {
//       next.amount = `Maximum amount allowed is ₹${amountLimits.maxAmount.toLocaleString("en-IN")}`;
//     }

//     if (!["super", "counter"].includes(form.settledIn)) {
//       next.settledIn = "settledIn must be super or counter";
//     }

//     if (!form.cardType) {
//       next.cardType = "Card type is required";
//     }

//     if (!form.cardNetwork) {
//       next.cardNetwork = "Card network is required";
//     }

//     if (!form.pgType) {
//       next.pgType = "Select a gateway type";
//     }

//     if (!pricingReady) {
//       next.markup = "Pricing must load successfully before payout";
//     } else {
//       const markup = Number(form.markup);
//       const minimumMarkup = Number(
//         pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//       );

//       if (
//         form.markup === "" ||
//         !Number.isFinite(markup) ||
//         markup < minimumMarkup ||
//         markup > 100
//       ) {
//         next.markup = `Customer markup must be at least ${minimumMarkup}% and at most 100%`;
//       }

//       const gatewayPct = Number(
//         pricing?.gatewayChargePercent ??
//           pricing?.pricing?.gatewayChargePercent ??
//           0
//       );
//       if (!next.markup && Number(totalText) < round2(gatewayPct + minimumMarkup)) {
//         next.markup = `Total must be at least ${round2(gatewayPct + minimumMarkup)}%`;
//       }
//       if (!next.markup && gatewayPct + markup > 100) {
//         next.markup = "Total charges (PG + markup) cannot exceed 100%";
//       }
//     }

//     if (form.binValue && form.binValue.length !== 6) {
//       next.binValue = "BIN must be first 6 digits of the card";
//     }

//     if (!form.senderName || form.senderName.trim().length < 3) {
//       next.senderName = "Name as per bank records is required";
//     }

//     if (!/^\d{8,18}$/.test(form.senderAccount)) {
//       next.senderAccount = "Account number must be 8–18 digits";
//     }

//     if (!IFSC_RE.test(form.senderIfsc)) {
//       next.senderIfsc = "Invalid IFSC";
//     }

//     if (!form.senderBank.trim()) {
//       next.senderBank = "Bank name is required";
//     }

//     if (!bankVerificationReady) {
//       next.bankVerification =
//         currentBankVerification?.message ||
//         "Verify the bank account before generating checkout";
//     }

//     if (!/^[6-9]\d{9}$/.test(form.senderMobile)) {
//       next.senderMobile = "Enter a valid 10-digit mobile";
//     }

//     if (!PAN_RE.test(form.senderPanNumber)) {
//       next.senderPanNumber = "Enter a valid PAN";
//     }

//     if (!["SAVINGS", "CURRENT"].includes(form.senderAccType)) {
//       next.senderAccType = "Account type must be SAVINGS or CURRENT";
//     }

//     return next;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (submitLock.current || loading) {
//       return;
//     }

//     const next = validate();

//     if (Object.keys(next).length) {
//       setErrors(next);

//       notify(
//         Object.values(next)[0] || "Please fix the errors in the form.",
//         "error"
//       );

//       return;
//     }

//     try {
//       submitLock.current = true;
//       setLoading(true);

//       const result = await createFinkedaCheckout({
//         purpose: "PAYOUT",
//         amount: Number(form.amount),

//         settledIn: form.settledIn,
//         cardType: form.cardType,
//         cardNetwork: form.cardNetwork,
//         pgType: form.pgType,

//         markup: String(form.markup),

//         binValue: form.binValue || undefined,

//         name: form.senderName.trim(),
//         mobile: form.senderMobile,

//         idempotencyKey: `po_${Date.now()}_${Math.random()
//           .toString(36)
//           .slice(2, 10)}`.slice(0, 64),

//         sender: {
//           sourceType: "MATM",
//           sourceId: customerSourceId,
//           senderName: form.senderName.trim(),
//           senderAccount: form.senderAccount,
//           senderIfsc: form.senderIfsc,
//           senderBank: form.senderBank.trim(),
//           senderMobile: form.senderMobile,
//           senderPanNumber: form.senderPanNumber,
//           senderAccType: form.senderAccType,
//         },
//       });

//       if (!result.success) {
//         notify(result.message || "Payout failed", "error");
//         return;
//       }

//       if (result.walletWarning) {
//         notify(result.walletWarning, "warning");
//       }

//       if (result.requiresKyc && result.kycUrl) {
//         notify(
//           "First-time PAN: complete KYC, then retry this payout.",
//           "success"
//         );

//         window.location.href = result.kycUrl;

//         return;
//       }

//       if (result.redirectionUrl) {
//         notify("Opening PG checkout…", "success");

//         window.open(result.redirectionUrl, "_blank", "noopener,noreferrer");

//         return;
//       }

//       notify(result.message || "Checkout created", "success");
//     } catch {
//       notify("Payout failed", "error");
//     } finally {
//       submitLock.current = false;
//       setLoading(false);
//     }
//   };

//   const fillBeneficiary = (customer) => {
//     setIsNewCustomer(false);
//     setCustomerSourceId(String(customer.id || customer._id || ""));

//     setForm((prev) => ({
//       ...prev,
//       senderName: customer.name || prev.senderName,
//       senderAccount: customer.accountNumber || prev.senderAccount,
//       senderIfsc: customer.ifsc || prev.senderIfsc,
//       senderBank: customer.bank || prev.senderBank,
//       senderMobile: customer.mobile || prev.senderMobile,
//       senderPanNumber: customer.pan || prev.senderPanNumber,
//       senderAccType: customer.accType || prev.senderAccType,
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       senderName: "",
//       senderAccount: "",
//       senderIfsc: "",
//       senderBank: "",
//       senderMobile: "",
//       senderPanNumber: "",
//       senderAccType: "",
//     }));
//   };

//   const handleNewCustomer = () => {
//     setIsNewCustomer(true);
//     setCustomerSourceId("");

//     setForm((prev) => ({
//       ...prev,
//       senderName: "",
//       senderAccount: "",
//       senderIfsc: "",
//       senderBank: "",
//       senderMobile: "",
//       senderPanNumber: "",
//       senderAccType: "SAVINGS",
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       senderName: "",
//       senderAccount: "",
//       senderIfsc: "",
//       senderBank: "",
//       senderMobile: "",
//       senderPanNumber: "",
//       senderAccType: "",
//     }));

//     setTimeout(() => {
//       nameInputRef.current?.focus();
//     }, 100);
//   };

//   // UI only: derived values for "Total - (PG + Hierarchy) = Extra"
//   const baseTotal = round2(
//     payoutPreview.gatewayChargePercent + payoutPreview.customerMarkup
//   );
//   const totalShown = Math.max(Number(totalText) || 0, baseTotal);
//   const extraShown = round2(Math.max(0, totalShown - baseTotal));

//   return (
//     <Main showRightPanel={false}>
//       <div className="flex flex-col">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "MATM Module" },
//             { label: "PG + Payout" },
//           ]}
//         />

//         <div className="w-full max-w-6xl mb-4 mt-4">
//           <h2 className="text-[15px] sm:text-lg font-semibold text-[var(--text-dark)] mb-3">
//             PG + Payout
//           </h2>

//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//               {/* LEFT SIDE */}
//               <div className="space-y-4">
//                 {/* CARD DETAILS */}
//                 <div className="ds-card p-4 sm:p-5">
//                   <h3 className="text-[14px] font-semibold mb-3">
//                     Card / Payment Details
//                   </h3>

//                   <div className="grid grid-cols-2 gap-4">
//                     {/* AMOUNT */}
//                     <div>
//                       <Field
//                         label="Amount"
//                         required
//                         name="amount"
//                         value={form.amount}
//                         onChange={handleChange}
//                         error={errors.amount}
//                         inputMode="numeric"
//                       />
//                       <p className="text-[11px] text-[var(--text-muted)] mt-1 font-medium">
//                         Allowed limit: Min ₹{amountLimits.minAmount} — Max ₹
//                         {amountLimits.maxAmount.toLocaleString("en-IN")}
//                       </p>
//                     </div>

//                     {/* RECEIVED AMOUNT */}
//                     <div>
//                       <label className="ds-label">Received Amount</label>

//                       <input
//                         type="text"
//                         value={`₹${payoutPreview.beneficiaryReceive.toFixed(2)}`}
//                         disabled
//                         readOnly
//                         className="ds-input bg-[var(--surface)] opacity-80 cursor-not-allowed"
//                       />

//                       <p className="text-[11px] text-[var(--text-muted)] mt-1">
//                         Beneficiary receives
//                       </p>
//                     </div>

//                     {/* SETTLEMENT */}
//                     <Select
//                       label="settledIn"
//                       required
//                       name="settledIn"
//                       value={form.settledIn}
//                       onChange={handleChange}
//                       options={[
//                         { value: "super", label: "super — Super Merchant" },
//                         { value: "counter", label: "counter — Sub Merchant" },
//                       ]}
//                       error={errors.settledIn}
//                     />

//                     {/* CARD TYPE */}
//                     <Select
//                       label="Card Type"
//                       required
//                       name="cardType"
//                       value={form.cardType}
//                       onChange={handleChange}
//                       options={availableCardTypes}
//                       error={errors.cardType}
//                     />

//                     {/* CARD NETWORK */}
//                     <Select
//                       label="Card Network"
//                       required
//                       name="cardNetwork"
//                       value={form.cardNetwork}
//                       onChange={handleChange}
//                       options={availableCardNetworks}
//                       error={errors.cardNetwork}
//                     />

//                     {/* GATEWAY */}
//                     <div>
//                       <label className="ds-label">
//                         pgType{" "}
//                         <span className="text-[var(--error-color)]">*</span>
//                       </label>

//                       <select
//                         name="pgType"
//                         value={form.pgType}
//                         onChange={handleChange}
//                         className={`ds-input ${
//                           errors.pgType ? "border-[var(--error-color)]" : ""
//                         }`}
//                       >
//                         {!gateways.length && (
//                           <option value="">Loading gateways from DB…</option>
//                         )}

//                         {gateways.map((gateway, index) => {
//                           const value =
//                             gateway.pgType ||
//                             gateway.code ||
//                             gateway.name ||
//                             String(gateway);

//                           return (
//                             <option key={`${value}-${index}`} value={value}>
//                               {gateway.name || gateway.code || value}
//                             </option>
//                           );
//                         })}
//                       </select>

//                       {errors.pgType && (
//                         <p className="text-[var(--error-color)] text-sm mt-1">
//                           {errors.pgType}
//                         </p>
//                       )}
//                     </div>
//                   </div>

//                   {/* APPLICABLE PRICING & CHARGES */}
//                   <div className="mt-4 border border-[var(--border-color)] rounded-xl p-2 sm:p-2 bg-[var(--surface)] shadow-sm space-y-4">
//                     <p className="text-[13px] font-semibold m-0">
//                       Applicable Pricing & Charges
//                     </p>

//                     {pricingLoading ? (
//                       <p className="text-[13px] text-[var(--text-muted)] m-0">
//                         Loading pricing…
//                       </p>
//                     ) : pricingError ? (
//                       <p className="text-[13px] text-[var(--error-color)] m-0">
//                         {pricingError}
//                       </p>
//                     ) : (
//                       <>
//                         {/* MARKUP: TOTAL (user types) - (PG + HIERARCHY) = EXTRA */}
//                         <div className="mt-3">
//                           <label className="ds-label">
//                             Customer Markup %{" "}
//                             <span className="text-[var(--error-color)]">*</span>
//                           </label>

//                           <div className="flex sm:flex-nowrap items-start gap-1">
//                             {/* TOTAL: user enters here */}
//                             <div className="flex-1 min-w-[60px]">
//                               <input
//                                 type="text"
//                                 value={totalText}
//                                 onChange={handleTotalChange}
//                                 onBlur={handleTotalBlur}
//                                 placeholder="Total %"
//                                 inputMode="decimal"
//                                 className={`ds-input ${
//                                   errors.markup
//                                     ? "border-[var(--error-color)]"
//                                     : ""
//                                 }`}
//                               />
//                               <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
//                                 Total
//                               </p>
//                             </div>

//                             <span className="pt-2 font-bold text-[16px]">-</span>

//                             {/* PG + HIERARCHY (locked) */} 
//                             <div className="flex-1 min-w-[55px]">
//                               <input
//                                 type="text"
//                                 value={`${baseTotal}%`}
//                                 disabled
//                                 readOnly
//                                 className="ds-input bg-[var(--surface)] opacity-80 cursor-not-allowed"
//                               />
//                               <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
//                                 PG 
//                                 {/* + Hierarchy */}  
//                               </p>
//                             </div>

//                             <span className="pt-2 font-bold text-[16px]">=</span>

//                             {/* EXTRA = Total - (PG + Hierarchy) (auto) */}
//                             <div className="flex-1 min-w-[60px]">
//                               <input
//                                 type="text"
//                                 value={`${extraShown}%`}
//                                 disabled
//                                 readOnly
//                                 className="ds-input bg-[var(--surface)] font-semibold cursor-not-allowed"
//                               />
//                               <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
//                                 {/* Extra */}
//                               </p>
//                             </div>
//                           </div>

//                           {/* <p className="text-[11px] text-[var(--text-muted)] mt-1 font-medium">
//                             {totalShown}% total −{" "}
//                             {round2(payoutPreview.gatewayChargePercent)}% PG −{" "}
//                             {payoutPreview.customerMarkup}% hierarchy ={" "}
//                             {extraShown}% extra · Minimum total {baseTotal}%
//                           </p> */}

//                           {errors.markup && (
//                             <p className="text-[var(--error-color)] text-sm mt-1">
//                               {errors.markup}
//                             </p>
//                           )}
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 </div>

//                 {/* BENEFICIARY DETAILS */}
//                 <div className="ds-card p-4 sm:p-5">
//                   <h3 className="text-[14px] font-semibold mb-3">
//                     Beneficiary Details
//                   </h3>

//                   <div className="grid grid-cols-2 gap-4">
//                     {/* NAME */}
//                     <div>
//                       <label className="ds-label">
//                         Name{" "}
//                         <span className="text-[var(--error-color)]">*</span>
//                       </label>

//                       <input
//                         ref={nameInputRef}
//                         type="text"
//                         name="senderName"
//                         value={form.senderName}
//                         onChange={handleChange}
//                         className={`ds-input ${
//                           errors.senderName ? "border-[var(--error-color)]" : ""
//                         }`}
//                         autoComplete="off"
//                       />

//                       {errors.senderName && (
//                         <p className="text-[var(--error-color)] text-sm mt-1">
//                           {errors.senderName}
//                         </p>
//                       )}
//                     </div>

//                     {/* MOBILE */}
//                     <Field
//                       label="Mobile"
//                       required
//                       name="senderMobile"
//                       value={form.senderMobile}
//                       onChange={handleChange}
//                       error={errors.senderMobile}
//                       maxLength={10}
//                       inputMode="numeric"
//                     />

//                     {/* BANK */}
//                     <Field
//                       label="Bank"
//                       required
//                       name="senderBank"
//                       value={form.senderBank}
//                       onChange={handleChange}
//                       error={errors.senderBank}
//                     />

//                     {/* IFSC */}
//                     <Field
//                       label="IFSC"
//                       required
//                       name="senderIfsc"
//                       value={form.senderIfsc}
//                       onChange={handleChange}
//                       error={errors.senderIfsc}
//                       maxLength={11}
//                     />

//                     {/* ACCOUNT NUMBER AND BANK VERIFICATION */}
//                     <div className="col-span-2">
//                       <label className="ds-label">
//                         A/C No{" "}
//                         <span className="text-[var(--error-color)]">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         name="senderAccount"
//                         value={form.senderAccount}
//                         onChange={handleChange}
//                         inputMode="numeric"
//                         maxLength={18}
//                         className={`ds-input min-w-0 w-full ${
//                           errors.senderAccount
//                             ? "border-[var(--error-color)]"
//                             : ""
//                         }`}
//                         placeholder="Enter account number"
//                       />
//                       {errors.senderAccount && (
//                         <p className="text-[var(--error-color)] text-sm mt-1">
//                           {errors.senderAccount}
//                         </p>
//                       )}
//                     </div>

//                     {/* PAN */}
//                     <Field
//                       label="PAN"
//                       required
//                       name="senderPanNumber"
//                       value={form.senderPanNumber}
//                       onChange={handleChange}
//                       error={errors.senderPanNumber}
//                       maxLength={10}
//                     />

//                     {/* ACCOUNT TYPE */}
//                     <Select
//                       label="Account Type"
//                       required
//                       name="senderAccType"
//                       value={form.senderAccType}
//                       onChange={handleChange}
//                       options={[
//                         { value: "SAVINGS", label: "SAVINGS" },
//                         { value: "CURRENT", label: "CURRENT" },
//                       ]}
//                       error={errors.senderAccType}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* CUSTOMER LOOKUP */}
//               <div>
//                 <CustomerLookup
//                   onSelect={fillBeneficiary}
//                   onNewCustomer={handleNewCustomer}
//                 />
//               </div>
//             </div>

//             {/* Reusable Bank Verification UI */}
//             <BankVerificationBox verification={bankVerification} className="mt-3" />

//             <button
//               type="submit"
//               disabled={
//                 loading ||
//                 !pricingReady ||
//                 !bankVerificationReady ||
//                 bankVerificationPolicyLoading
//               }
//               className="ds-btn ds-btn-primary mt-2 mb-6"
//             >
//               {loading ? "Processing payout…" : "Generate Checkout"}
//             </button>

//             {/* TEMPORARY: Finkeda pricing breakdown for testing only.
//                 Remove/comment this section before production. */}
//             {/* <div className="mt-6">
//               <FinkedaPricingBreakdownBox
//                 amount={payoutPreview.amountEntered}
//                 pricing={pricing}
//                 loading={pricingLoading}
//                 error={pricingError}
//                 breakdown={{
//                   amount: payoutPreview.amountEntered,
//                   gatewayChargePercent: payoutPreview.gatewayChargePercent,
//                   gatewayChargeAmount: payoutPreview.gatewayChargeAmount,
//                   hierarchyPercent: payoutPreview.hierarchyPercent,
//                   hierarchyAmount: payoutPreview.hierarchyAmount,
//                   extraMarkup: payoutPreview.extraMarkup,
//                   extraMarkupAmount: payoutPreview.extraMarkupAmount,
//                   customerExtraPercent: payoutPreview.customerExtraPercent,
//                   customerExtraAmount: payoutPreview.customerExtraAmount,
//                   finalCustomerMarkup: payoutPreview.finalCustomerMarkup,
//                   finalCustomerMarkupAmount:
//                     payoutPreview.finalCustomerMarkupAmount,
//                   totalCharges: payoutPreview.totalCharges,
//                   customerWillReceive: payoutPreview.beneficiaryReceive,
//                   role: payoutPreview.role,
//                   planCode: payoutPreview.planCode,
//                 }}
//               />
//             </div> */}

//             {!pricingReady && !pricingLoading && (
//               <p className="text-[13px] text-[var(--error-color)] m-0">
//                 Payout submission is blocked until pricing loads successfully.
//               </p>
//             )}
//           </form>
//         </div>
//       </div>
//     </Main>
//   );
// };

// const Field = ({ label, error, required, ...props }) => (
//   <div>
//     <label className="ds-label">
//       {label}{" "}
//       {required && <span className="text-[var(--error-color)]">*</span>}
//     </label>

//     <input
//       {...props}
//       className={`ds-input ${error ? "border-[var(--error-color)]" : ""}`}
//     />

//     {error && (
//       <p className="text-[var(--error-color)] text-sm mt-1">{error}</p>
//     )}
//   </div>
// );

// const Select = ({ label, options, error, required, ...props }) => (
//   <div>
//     <label className="ds-label">
//       {label}{" "}
//       {required && <span className="text-[var(--error-color)]">*</span>}
//     </label>

//     <select
//       {...props}
//       className={`ds-input ${error ? "border-[var(--error-color)]" : ""}`}
//     >
//       {options.map((option) => (
//         <option key={option.value} value={option.value}>
//           {option.label}
//         </option>
//       ))}
//     </select>

//     {error && (
//       <p className="text-[var(--error-color)] text-sm mt-1">{error}</p>
//     )}
//   </div>
// );

// export default PgPayout;

// import React, {
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";
// import Main from "../Main";
// import {
//   createFinkedaCheckout,
//   fetchFinkedaGateways,
//   fetchFinkedaPayoutPricing,
// } from "../../api/finkedaApi";
// import { useNotify } from "../../context/NotifyContext";
// import CustomerLookup from "../../components/CustomerLookup";
// import useBankVerification from "../../hooks/useBankVerification";
// import BankVerificationBox from "../../components/BankVerificationBox";

// // TEMPORARY: Finkeda pricing breakdown for testing only.
// // Remove/comment this section before production.
// import FinkedaPricingBreakdownBox from "../../components/FinkedaPricingBreakdownBox";

// const PAN_RE = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
// const IFSC_RE = /^[A-Z]{4}0[A-Z0-9]{6}$/;

// function round2(x) {
//   return Math.round((Number(x) + Number.EPSILON) * 100) / 100;
// }

// const PgPayout = () => {
//   const { notify } = useNotify();

//   const submitLock = useRef(false);
//   const nameInputRef = useRef(null);

//   const [loading, setLoading] = useState(false);
//   const [gateways, setGateways] = useState([]);
//   const [errors, setErrors] = useState({});

//   const [pricing, setPricing] = useState(null);
//   const [pricingLoading, setPricingLoading] = useState(true);
//   const [pricingError, setPricingError] = useState("");

//   const [form, setForm] = useState({
//     amount: "",
//     settledIn: "super",
//     cardType: "CREDITCARD",
//     cardNetwork: "MASTERCARD",
//     pgType: "",
//     markup: "", // total customer markup (same as before, goes to backend)
//     binValue: "",

//     senderName: "",
//     senderAccount: "",
//     senderIfsc: "",
//     senderBank: "",
//     senderMobile: "",
//     senderPanNumber: "",
//     senderAccType: "SAVINGS",
//   });


//   const [totalText, setTotalText] = useState("");
//   const totalTouched = useRef(false);
//   const totalTimer = useRef(null); // 3s debounce for minimum check

//   useEffect(() => () => clearTimeout(totalTimer.current), []);

//   const [isNewCustomer, setIsNewCustomer] = useState(false);
//   const [customerSourceId, setCustomerSourceId] = useState("");

//   const bankVerification = useBankVerification({
//     accountNumber: form.senderAccount,
//     ifsc: form.senderIfsc,
//     name: form.senderName,
//     bankId: form.senderBank,
//     sourceType: "MATM",
//     sourceId: customerSourceId,
//     onVerified: (result) => {
//       if (result.beneficiaryName) {
//         setForm((current) => ({
//           ...current,
//           senderName: result.beneficiaryName,
//         }));
//       }
//     },
//   });

//   const {
//     result: currentBankVerification,
//     ready: bankVerificationReady,
//     policyLoading: bankVerificationPolicyLoading,
//   } = bankVerification;

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await fetchFinkedaGateways();

//         const list = Array.isArray(res?.data)
//           ? res.data
//           : res?.data?.gateways || [];

//         setGateways(list);

//         const firstGateway = list?.[0];
//         const firstPg = firstGateway?.pgType || firstGateway?.code || "";
//         const firstCt = firstGateway?.cardTypes?.[0] || "CREDITCARD";
//         const firstDetail =
//           firstGateway?.cardTypeDetails?.find((d) => d.cardType === firstCt) ||
//           firstGateway?.cardTypeDetails?.[0];
//         const firstNet = firstDetail?.networks?.[0] || "MASTERCARD";

//         if (firstPg) {
//           setForm((prev) => ({
//             ...prev,
//             pgType: prev.pgType || firstPg,
//             cardType: prev.cardType || firstCt,
//             cardNetwork: prev.cardNetwork || firstNet,
//           }));
//         }
//       } catch {
//         setGateways([]);
//       }
//     })();
//   }, []);

//   const selectedGateway = useMemo(() => {
//     return (
//       gateways.find(
//         (g) =>
//           (g.pgType || g.code) === form.pgType ||
//           g.code === form.pgType
//       ) ||
//       gateways[0] ||
//       null
//     );
//   }, [gateways, form.pgType]);

//   const availableCardTypes = useMemo(() => {
//     if (!selectedGateway?.cardTypes?.length) {
//       return [{ value: "CREDITCARD", label: "CREDITCARD" }];
//     }
//     return selectedGateway.cardTypes.map((ct) => ({ value: ct, label: ct }));
//   }, [selectedGateway]);

//   const selectedCardTypeDetail = useMemo(() => {
//     if (!selectedGateway?.cardTypeDetails?.length) return null;
//     return (
//       selectedGateway.cardTypeDetails.find(
//         (d) => d.cardType === form.cardType
//       ) ||
//       selectedGateway.cardTypeDetails[0] ||
//       null
//     );
//   }, [selectedGateway, form.cardType]);

//   const availableCardNetworks = useMemo(() => {
//     const list =
//       selectedCardTypeDetail?.networks ||
//       selectedGateway?.networks?.map((n) => n.networkType) || [
//         "MASTERCARD",
//         "VISACARD",
//         "RUPAYCARD",
//       ];
//     const unique = [...new Set(list.filter(Boolean))];
//     return unique.map((net) => ({ value: net, label: net }));
//   }, [selectedCardTypeDetail, selectedGateway]);

//   const amountLimits = useMemo(() => {
//     const netLimit = selectedCardTypeDetail?.networkLimits?.[form.cardNetwork];
//     const min = netLimit?.minAmount ?? selectedCardTypeDetail?.minAmount ?? 1;
//     const max = netLimit?.maxAmount ?? selectedCardTypeDetail?.maxAmount ?? 50000;
//     return { minAmount: Number(min) || 1, maxAmount: Number(max) || 50000 };
//   }, [selectedCardTypeDetail, form.cardNetwork]);

//   useEffect(() => {
//     const timer = setTimeout(async () => {
//       try {
//         setPricingLoading(true);
//         setPricingError("");

//         const res = await fetchFinkedaPayoutPricing({
//           amount: form.amount || 0,
//           pgType: form.pgType || undefined,
//           cardType: form.cardType || undefined,
//           cardNetwork: form.cardNetwork || undefined,
//         });

//         if (!res.success || !res.data) {
//           setPricing(null);
//           setPricingError(
//             res.message ||
//               "Unable to load pricing. Payout is blocked."
//           );
//           return;
//         }

//         const data = res.data;

//         console.log("get the pgpayout data",data)

//         if (
//           data.customerMarkup == null &&
//           data.pricing?.customerMarkup == null
//         ) {
//           setPricing(null);
//           setPricingError(
//             "Incomplete pricing received. Payout is blocked."
//           );
//           return;
//         }

//         const minMarkup = Number(
//           data.customerMarkup ?? data.pricing?.customerMarkup ?? 0
//         );
//         setPricing(data);

//         setForm((prev) => {
//           const currentMarkupNum = Number(prev.markup);
//           const needsDefault =
//             prev.markup === "" ||
//             prev.markup === "0" ||
//             !Number.isFinite(currentMarkupNum) ||
//             currentMarkupNum < minMarkup;
//           return {
//             ...prev,
//             markup: needsDefault ? String(minMarkup) : prev.markup,
//           };
//         });
//       } catch {
//         setPricing(null);
//         setPricingError(
//           "Unable to load pricing. Payout is blocked."
//         );
//       } finally {
//         setPricingLoading(false);
//       }
//     }, 250);

//     return () => clearTimeout(timer);
//   }, [form.pgType, form.cardType, form.cardNetwork, form.amount]);

//   /*
//    * UI only: pricing badalne par (pgType / cardType / network / amount)
//    * total ko sync rakhta hai aur form.markup = total - gateway set karta hai.
//    * Agar user ne total nahi chheda to total = gateway + customerMarkup (minimum).
//    */
//   useEffect(() => {
//     if (!pricing) return;
//     const gateway = Number(
//       pricing?.gatewayChargePercent ??
//         pricing?.pricing?.gatewayChargePercent ??
//         0
//     );
//     const min = Number(
//       pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//     );
//     const base = round2(gateway + min);
//     const typed = Number(totalText);

//     const total =
//       !totalTouched.current || !Number.isFinite(typed) || typed < base
//         ? base
//         : Math.min(typed, 100);

//     if (String(total) !== totalText) setTotalText(String(total));
//     setForm((prev) => ({
//       ...prev,
//       markup: String(round2(total - gateway)),
//     }));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pricing]);

//   /*
//    * Payout preview calculation:
//    * Customer Charge = (amount * actualMarkup) / 100
//    * Beneficiary Receive = amount - Customer Charge
//    * Performer Earning = Extra markup charged above minimum customer markup
//    */
//   const payoutPreview = useMemo(() => {
//     const amount = Number(form.amount) || 0;
//     const enteredMarkup = Number(form.markup) || 0;

//     const gatewayChargePercent = Number(
//       pricing?.gatewayChargePercent ??
//         pricing?.pricing?.gatewayChargePercent ??
//         0
//     );
//     const hierarchyPercent = Number(
//       pricing?.hierarchyPercent ??
//         pricing?.pricing?.hierarchyPercent ??
//         0
//     );
//     const extraMarkup = Number(
//       pricing?.extraMarkup ??
//         pricing?.pricing?.extraMarkup ??
//         0
//     );
//     const customerMarkup = Number(
//       pricing?.customerMarkup ??
//         pricing?.pricing?.customerMarkup ??
//         round2(hierarchyPercent + extraMarkup)
//     );

//     const actualMarkup = Math.max(enteredMarkup, customerMarkup);
//     const finalCustomerMarkup = actualMarkup;

//     const customerExtraPercent = round2(
//       Math.max(0, actualMarkup - customerMarkup)
//     );

//     // Charge & Markup Amounts based on backend pricing
//     const gatewayChargeAmount = round2((amount * gatewayChargePercent) / 100);
//     const hierarchyAmount = round2((amount * hierarchyPercent) / 100);
//     const extraMarkupAmount = round2((amount * extraMarkup) / 100);
//     const customerExtraAmount = round2((amount * customerExtraPercent) / 100);
//     const finalCustomerMarkupAmount = round2((amount * finalCustomerMarkup) / 100);
//     const totalCharges = round2(gatewayChargeAmount + finalCustomerMarkupAmount);
//     const totalChargesPercent = round2(gatewayChargePercent + finalCustomerMarkup);
//     const customerCharge = totalCharges;
//     const beneficiaryReceive = round2(Math.max(0, amount - totalCharges));
//     const walletEarning = customerExtraAmount;

//     return {
//       amountEntered: round2(amount),
//       customerMarkup,
//       actualMarkup,
//       gatewayChargePercent,
//       gatewayChargeAmount,
//       hierarchyPercent,
//       hierarchyAmount,
//       extraMarkup,
//       extraMarkupAmount,
//       customerExtraPercent,
//       customerExtraAmount,
//       finalCustomerMarkup,
//       finalCustomerMarkupAmount,
//       totalCharges,
//       totalChargesPercent,
//       customerCharge,
//       beneficiaryReceive,
//       walletEarning,
//       role:
//         pricing?.performerRole ||
//         pricing?.pricing?.performerRole ||
//         "retailer",
//       planCode:
//         pricing?.planCode ||
//         pricing?.pricing?.planCode ||
//         "",
//     };
//   }, [form.amount, form.markup, pricing]);

//   const pricingReady = Boolean(
//     pricing &&
//       (pricing.customerMarkup != null ||
//         pricing.pricing?.customerMarkup != null)
//   );

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (
//       [
//         "senderName",
//         "senderAccount",
//         "senderIfsc",
//         "senderBank",
//         "senderMobile",
//         "senderPanNumber",
//         "senderAccType",
//       ].includes(name)
//     ) {
//       setCustomerSourceId("");
//     }

//     let next = value;

//     if (
//       ["amount", "senderAccount", "senderMobile", "binValue"].includes(name)
//     ) {
//       next = value.replace(/\D/g, "");
//     }

//     if (name === "amount" && Number(next) > amountLimits.maxAmount) {
//       next = String(amountLimits.maxAmount);
//     }

//     if (name === "binValue") {
//       next = next.slice(0, 6);
//     }

//     if (name === "senderMobile") {
//       next = next.slice(0, 10);
//     }

//     if (name === "senderAccount") {
//       next = next.slice(0, 18);
//     }

//     if (name === "senderIfsc" || name === "senderPanNumber") {
//       next = value.toUpperCase().replace(/\s/g, "");
//     }

//     if (name === "markup") {
//       next = value.replace(/[^\d.]/g, "");

//       const parts = next.split(".");

//       if (parts.length > 2) {
//         next = `${parts[0]}.${parts.slice(1).join("")}`;
//       }

//       if (Number(next) > 100) {
//         next = "100";
//       }

//       /*
//        * Never allow markup below minimum.
//        */
//       const minMarkup = Number(
//         pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//       );
//       if (
//         next !== "" &&
//         pricing &&
//         Number.isFinite(minMarkup) &&
//         Number(next) < minMarkup
//       ) {
//         next = String(minMarkup);
//       }
//     }

//     if (name === "pgType") {
//       const g = gateways.find((item) => (item.pgType || item.code) === next);
//       const nextCardType = g?.cardTypes?.[0] || "CREDITCARD";
//       const ctDetail =
//         g?.cardTypeDetails?.find((d) => d.cardType === nextCardType) ||
//         g?.cardTypeDetails?.[0];
//       const nextNetwork = ctDetail?.networks?.[0] || "MASTERCARD";
//       setForm((prev) => ({
//         ...prev,
//         pgType: next,
//         cardType: nextCardType,
//         cardNetwork: nextNetwork,
//       }));
//       if (errors.pgType) setErrors((prev) => ({ ...prev, pgType: "" }));
//       return;
//     }

//     if (name === "cardType") {
//       const g = gateways.find(
//         (item) => (item.pgType || item.code) === form.pgType
//       );
//       const ctDetail =
//         g?.cardTypeDetails?.find((d) => d.cardType === next) ||
//         g?.cardTypeDetails?.[0];
//       const currentNetworkValid = ctDetail?.networks?.includes(form.cardNetwork);
//       const nextNetwork = currentNetworkValid
//         ? form.cardNetwork
//         : ctDetail?.networks?.[0] || "MASTERCARD";
//       setForm((prev) => ({
//         ...prev,
//         cardType: next,
//         cardNetwork: nextNetwork,
//       }));
//       if (errors.cardType) setErrors((prev) => ({ ...prev, cardType: "" }));
//       return;
//     }

//     setForm((prev) => ({
//       ...prev,
//       [name]: next,
//     }));

//     if (errors[name]) {
//       setErrors((prev) => ({
//         ...prev,
//         [name]: "",
//       }));
//     }

//     // account / IFSC / name badalne par purana bank-verification error hata do
//     if (
//       ["senderAccount", "senderIfsc", "senderName", "senderBank"].includes(
//         name
//       ) &&
//       errors.bankVerification
//     ) {
//       setErrors((prev) => ({ ...prev, bankVerification: "" }));
//     }
//   };

//   /*
//    * UI only: user TOTAL % type karta hai (e.g. 3).
//    * Total - PG charge = customer markup (customerMarkup + extra).
//    * form.markup = total - gateway  (backend ko wahi customer markup jata hai).
//    */
//   const handleTotalChange = (e) => {
//     let v = e.target.value.replace(/[^\d.]/g, "");

//     const parts = v.split(".");
//     if (parts.length > 2) v = `${parts[0]}.${parts.slice(1).join("")}`;

//     const [i, d] = v.split(".");
//     if (d !== undefined) v = `${i}.${d.slice(0, 2)}`;

//     if (Number(v) > 100) v = "100";

//     const gateway = Number(
//       pricing?.gatewayChargePercent ??
//         pricing?.pricing?.gatewayChargePercent ??
//         0
//     );
//     const min = Number(
//       pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//     );
//     const base = round2(gateway + min);

//     // Typing ke time har value allowed hai.
//     totalTouched.current = v !== "";
//     setTotalText(v);

//     // 3 second typing band hone ke baad check: kam ho to minimum dikhao,
//     // zyada ho to kuch nahi karna.
//     clearTimeout(totalTimer.current);
//     totalTimer.current = setTimeout(() => {
//       setTotalText((prev) => {
//         const n = Number(prev);
//         if (prev === "" || !Number.isFinite(n) || n < base) {
//           totalTouched.current = false;
//           return String(base);
//         }
//         return prev;
//       });
//     }, 3000);

//     const total = Math.max(Number(v) || 0, base);
//     setForm((prev) => ({
//       ...prev,
//       markup: String(round2(total - gateway)),
//     }));

//     if (errors.markup) setErrors((prev) => ({ ...prev, markup: "" }));
//   };

//   // Field se bahar jaate hi bhi same check (3s ka wait nahi).
//   const handleTotalBlur = () => {
//     const gateway = Number(
//       pricing?.gatewayChargePercent ??
//         pricing?.pricing?.gatewayChargePercent ??
//         0
//     );
//     const min = Number(
//       pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//     );
//     const base = round2(gateway + min);
//     const typed = Number(totalText);

//     clearTimeout(totalTimer.current);
//     if (totalText === "" || !Number.isFinite(typed) || typed < base) {
//       totalTouched.current = false;
//       setTotalText(String(base));
//     }
//   };

//   const validate = () => {
//     const next = {};

//     const amount = Number(form.amount);

//     if (!Number.isInteger(amount) || amount <= 0) {
//       next.amount = "Amount must be a positive whole number";
//     } else if (amount < amountLimits.minAmount) {
//       next.amount = `Minimum amount allowed is ₹${amountLimits.minAmount}`;
//     } else if (amount > amountLimits.maxAmount) {
//       next.amount = `Maximum amount allowed is ₹${amountLimits.maxAmount.toLocaleString("en-IN")}`;
//     }

//     if (!["super", "counter"].includes(form.settledIn)) {
//       next.settledIn = "settledIn must be super or counter";
//     }

//     if (!form.cardType) {
//       next.cardType = "Card type is required";
//     }

//     if (!form.cardNetwork) {
//       next.cardNetwork = "Card network is required";
//     }

//     if (!form.pgType) {
//       next.pgType = "Select a gateway type";
//     }

//     if (!pricingReady) {
//       next.markup = "Pricing must load successfully before payout";
//     } else {
//       const markup = Number(form.markup);
//       const minimumMarkup = Number(
//         pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
//       );

//       if (
//         form.markup === "" ||
//         !Number.isFinite(markup) ||
//         markup < minimumMarkup ||
//         markup > 100
//       ) {
//         next.markup = `Customer markup must be at least ${minimumMarkup}% and at most 100%`;
//       }

//       const gatewayPct = Number(
//         pricing?.gatewayChargePercent ??
//           pricing?.pricing?.gatewayChargePercent ??
//           0
//       );
//       if (!next.markup && Number(totalText) < round2(gatewayPct + minimumMarkup)) {
//         next.markup = `Total must be at least ${round2(gatewayPct + minimumMarkup)}%`;
//       }
//       if (!next.markup && gatewayPct + markup > 100) {
//         next.markup = "Total charges (PG + markup) cannot exceed 100%";
//       }
//     }

//     if (form.binValue && form.binValue.length !== 6) {
//       next.binValue = "BIN must be first 6 digits of the card";
//     }

//     if (!form.senderName || form.senderName.trim().length < 3) {
//       next.senderName = "Name as per bank records is required";
//     }

//     if (!/^\d{8,18}$/.test(form.senderAccount)) {
//       next.senderAccount = "Account number must be 8–18 digits";
//     }

//     if (!IFSC_RE.test(form.senderIfsc)) {
//       next.senderIfsc = "Invalid IFSC";
//     }

//     if (!form.senderBank.trim()) {
//       next.senderBank = "Bank name is required";
//     }

//     if (!bankVerificationReady) {
//       next.bankVerification =
//         currentBankVerification?.message ||
//         "Verify the bank account before generating checkout";
//     }

//     if (!/^[6-9]\d{9}$/.test(form.senderMobile)) {
//       next.senderMobile = "Enter a valid 10-digit mobile";
//     }

//     if (!PAN_RE.test(form.senderPanNumber)) {
//       next.senderPanNumber = "Enter a valid PAN";
//     }

//     if (!["SAVINGS", "CURRENT"].includes(form.senderAccType)) {
//       next.senderAccType = "Account type must be SAVINGS or CURRENT";
//     }

//     return next;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (submitLock.current || loading) {
//       return;
//     }

//     const next = validate();

//     if (Object.keys(next).length) {
//       setErrors(next);

//       notify(
//         Object.values(next)[0] || "Please fix the errors in the form.",
//         "error"
//       );

//       return;
//     }

//     try {
//       submitLock.current = true;
//       setLoading(true);

//       const result = await createFinkedaCheckout({
//         purpose: "PAYOUT",
//         amount: Number(form.amount),

//         settledIn: form.settledIn,
//         cardType: form.cardType,
//         cardNetwork: form.cardNetwork,
//         pgType: form.pgType,

//         markup: String(form.markup),

//         binValue: form.binValue || undefined,

//         name: form.senderName.trim(),
//         mobile: form.senderMobile,

//         idempotencyKey: `po_${Date.now()}_${Math.random()
//           .toString(36)
//           .slice(2, 10)}`.slice(0, 64),

//         sender: {
//           sourceType: "MATM",
//           sourceId: customerSourceId,
//           senderName: form.senderName.trim(),
//           senderAccount: form.senderAccount,
//           senderIfsc: form.senderIfsc,
//           senderBank: form.senderBank.trim(),
//           senderMobile: form.senderMobile,
//           senderPanNumber: form.senderPanNumber,
//           senderAccType: form.senderAccType,
//         },
//       });

//       if (!result.success) {
//         notify(result.message || "Payout failed", "error");
//         return;
//       }

//       if (result.walletWarning) {
//         notify(result.walletWarning, "warning");
//       }

//       if (result.requiresKyc && result.kycUrl) {
//         notify(
//           "First-time PAN: complete KYC, then retry this payout.",
//           "success"
//         );

//         window.location.href = result.kycUrl;

//         return;
//       }

//       if (result.redirectionUrl) {
//         notify("Opening PG checkout…", "success");

//         window.open(result.redirectionUrl, "_blank", "noopener,noreferrer");

//         return;
//       }

//       notify(result.message || "Checkout created", "success");
//     } catch {
//       notify("Payout failed", "error");
//     } finally {
//       submitLock.current = false;
//       setLoading(false);
//     }
//   };

//   const fillBeneficiary = (customer) => {
//     setIsNewCustomer(false);
//     setCustomerSourceId(String(customer.id || customer._id || ""));

//     setForm((prev) => ({
//       ...prev,
//       senderName: customer.name || prev.senderName,
//       senderAccount: customer.accountNumber || prev.senderAccount,
//       senderIfsc: customer.ifsc || prev.senderIfsc,
//       senderBank: customer.bank || prev.senderBank,
//       senderMobile: customer.mobile || prev.senderMobile,
//       senderPanNumber: customer.pan || prev.senderPanNumber,
//       senderAccType: customer.accType || prev.senderAccType,
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       senderName: "",
//       senderAccount: "",
//       senderIfsc: "",
//       senderBank: "",
//       senderMobile: "",
//       senderPanNumber: "",
//       senderAccType: "",
//       bankVerification: "",
//     }));
//   };

//   const handleNewCustomer = () => {
//     setIsNewCustomer(true);
//     setCustomerSourceId("");

//     setForm((prev) => ({
//       ...prev,
//       senderName: "",
//       senderAccount: "",
//       senderIfsc: "",
//       senderBank: "",
//       senderMobile: "",
//       senderPanNumber: "",
//       senderAccType: "SAVINGS",
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       senderName: "",
//       senderAccount: "",
//       senderIfsc: "",
//       senderBank: "",
//       senderMobile: "",
//       senderPanNumber: "",
//       senderAccType: "",
//       bankVerification: "",
//     }));

//     setTimeout(() => {
//       nameInputRef.current?.focus();
//     }, 100);
//   };

//   // UI only: derived values for "Total - (PG + Hierarchy) = Extra"
//   const baseTotal = round2(
//     payoutPreview.gatewayChargePercent + payoutPreview.customerMarkup
//   );
//   const totalShown = Math.max(Number(totalText) || 0, baseTotal);
//   const extraShown = round2(Math.max(0, totalShown - baseTotal));

//   return (
//     <Main showRightPanel={false}>
//       <div className="flex flex-col">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "MATM Module" },
//             { label: "PG + Payout" },
//           ]}
//         />

//         <div className="w-full max-w-6xl mb-4 mt-4">
//           <h2 className="text-[15px] sm:text-lg font-semibold text-[var(--text-dark)] mb-3">
//             PG + Payout
//           </h2>

//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//               {/* LEFT SIDE */}
//               <div className="space-y-4">
//                 {/* CARD DETAILS */}
//                 <div className="ds-card p-4 sm:p-5">
//                   <h3 className="text-[14px] font-semibold mb-3">
//                     Card / Payment Details
//                   </h3>

//                   <div className="grid grid-cols-2 gap-4">
//                     {/* AMOUNT */}
//                     <div>
//                       <Field
//                         label="Amount"
//                         required
//                         name="amount"
//                         value={form.amount}
//                         onChange={handleChange}
//                         error={errors.amount}
//                         inputMode="numeric"
//                       />
//                       <p className="text-[11px] text-[var(--text-muted)] mt-1 font-medium">
//                         Allowed limit: Min ₹{amountLimits.minAmount} — Max ₹
//                         {amountLimits.maxAmount.toLocaleString("en-IN")}
//                       </p>
//                     </div>

//                     {/* RECEIVED AMOUNT */}
//                     <div>
//                       <label className="ds-label">Received Amount</label>

//                       <input
//                         type="text"
//                         value={`₹${payoutPreview.beneficiaryReceive.toFixed(2)}`}
//                         disabled
//                         readOnly
//                         className="ds-input bg-[var(--surface)] opacity-80 cursor-not-allowed"
//                       />

//                       <p className="text-[11px] text-[var(--text-muted)] mt-1">
//                         Beneficiary receives
//                       </p>
//                     </div>

//                     {/* SETTLEMENT */}
//                     <Select
//                       label="settledIn"
//                       required
//                       name="settledIn"
//                       value={form.settledIn}
//                       onChange={handleChange}
//                       options={[
//                         { value: "super", label: "super — Super Merchant" },
//                         { value: "counter", label: "counter — Sub Merchant" },
//                       ]}
//                       error={errors.settledIn}
//                     />

//                     {/* CARD TYPE */}
//                     <Select
//                       label="Card Type"
//                       required
//                       name="cardType"
//                       value={form.cardType}
//                       onChange={handleChange}
//                       options={availableCardTypes}
//                       error={errors.cardType}
//                     />

//                     {/* CARD NETWORK */}
//                     <Select
//                       label="Card Network"
//                       required
//                       name="cardNetwork"
//                       value={form.cardNetwork}
//                       onChange={handleChange}
//                       options={availableCardNetworks}
//                       error={errors.cardNetwork}
//                     />

//                     {/* GATEWAY */}
//                     <div>
//                       <label className="ds-label">
//                         pgType{" "}
//                         <span className="text-[var(--error-color)]">*</span>
//                       </label>

//                       <select
//                         name="pgType"
//                         value={form.pgType}
//                         onChange={handleChange}
//                         className={`ds-input ${
//                           errors.pgType ? "border-[var(--error-color)]" : ""
//                         }`}
//                       >
//                         {!gateways.length && (
//                           <option value="">Loading gateways from DB…</option>
//                         )}

//                         {gateways.map((gateway, index) => {
//                           const value =
//                             gateway.pgType ||
//                             gateway.code ||
//                             gateway.name ||
//                             String(gateway);

//                           return (
//                             <option key={`${value}-${index}`} value={value}>
//                               {gateway.name || gateway.code || value}
//                             </option>
//                           );
//                         })}
//                       </select>

//                       {errors.pgType && (
//                         <p className="text-[var(--error-color)] text-sm mt-1">
//                           {errors.pgType}
//                         </p>
//                       )}
//                     </div>
//                   </div>

//                   {/* APPLICABLE PRICING & CHARGES */}
//                   <div className="mt-4 border border-[var(--border-color)] rounded-xl p-2 sm:p-2 bg-[var(--surface)] shadow-sm space-y-4">
//                     <p className="text-[13px] font-semibold m-0">
//                       Applicable Pricing & Charges
//                     </p>

//                     {pricingLoading ? (
//                       <p className="text-[13px] text-[var(--text-muted)] m-0">
//                         Loading pricing…
//                       </p>
//                     ) : pricingError ? (
//                       <p className="text-[13px] text-[var(--error-color)] m-0">
//                         {pricingError}
//                       </p>
//                     ) : (
//                       <>
//                         {/* MARKUP: TOTAL (user types) - (PG + HIERARCHY) = EXTRA */}
//                         <div className="mt-3">
//                           <label className="ds-label">
//                             Customer Markup %{" "}
//                             <span className="text-[var(--error-color)]">*</span>
//                           </label>

//                           <div className="flex sm:flex-nowrap items-start gap-1">
//                             {/* TOTAL: user enters here */}
//                             <div className="flex-1 min-w-[60px]">
//                               <input
//                                 type="text"
//                                 value={totalText}
//                                 onChange={handleTotalChange}
//                                 onBlur={handleTotalBlur}
//                                 placeholder="Total %"
//                                 inputMode="decimal"
//                                 className={`ds-input ${
//                                   errors.markup
//                                     ? "border-[var(--error-color)]"
//                                     : ""
//                                 }`}
//                               />
//                               <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
//                                 Total
//                               </p>
//                             </div>

//                             <span className="pt-2 font-bold text-[16px]">-</span>

//                             {/* PG + HIERARCHY (locked) */}
//                             <div className="flex-1 min-w-[55px]">
//                               <input
//                                 type="text"
//                                 value={`${baseTotal}%`}
//                                 disabled
//                                 readOnly
//                                 className="ds-input bg-[var(--surface)] opacity-80 cursor-not-allowed"
//                               />
//                               <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
//                                 PG
//                                 {/* + Hierarchy */}
//                               </p>
//                             </div>

//                             <span className="pt-2 font-bold text-[16px]">=</span>

//                             {/* EXTRA = Total - (PG + Hierarchy) (auto) */}
//                             <div className="flex-1 min-w-[60px]">
//                               <input
//                                 type="text"
//                                 value={`${extraShown}%`}
//                                 disabled
//                                 readOnly
//                                 className="ds-input bg-[var(--surface)] font-semibold cursor-not-allowed"
//                               />
//                               <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
//                                 {/* Extra */}
//                               </p>
//                             </div>
//                           </div>

//                           {/* <p className="text-[11px] text-[var(--text-muted)] mt-1 font-medium">
//                             {totalShown}% total −{" "}
//                             {round2(payoutPreview.gatewayChargePercent)}% PG −{" "}
//                             {payoutPreview.customerMarkup}% hierarchy ={" "}
//                             {extraShown}% extra · Minimum total {baseTotal}%
//                           </p> */}

//                           {errors.markup && (
//                             <p className="text-[var(--error-color)] text-sm mt-1">
//                               {errors.markup}
//                             </p>
//                           )}
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 </div>

//                 {/* BENEFICIARY DETAILS */}
//                 <div className="ds-card p-4 sm:p-5">
//                   <h3 className="text-[14px] font-semibold mb-3">
//                     Beneficiary Details
//                   </h3>

//                   <div className="grid grid-cols-2 gap-4">
//                     {/* NAME */}
//                     <div>
//                       <label className="ds-label">
//                         Name{" "}
//                         <span className="text-[var(--error-color)]">*</span>
//                       </label>

//                       <input
//                         ref={nameInputRef}
//                         type="text"
//                         name="senderName"
//                         value={form.senderName}
//                         onChange={handleChange}
//                         className={`ds-input ${
//                           errors.senderName ? "border-[var(--error-color)]" : ""
//                         }`}
//                         autoComplete="off"
//                       />

//                       {errors.senderName && (
//                         <p className="text-[var(--error-color)] text-sm mt-1">
//                           {errors.senderName}
//                         </p>
//                       )}
//                     </div>

//                     {/* MOBILE */}
//                     <Field
//                       label="Mobile"
//                       required
//                       name="senderMobile"
//                       value={form.senderMobile}
//                       onChange={handleChange}
//                       error={errors.senderMobile}
//                       maxLength={10}
//                       inputMode="numeric"
//                     />

//                     {/* BANK */}
//                     <Field
//                       label="Bank"
//                       required
//                       name="senderBank"
//                       value={form.senderBank}
//                       onChange={handleChange}
//                       error={errors.senderBank}
//                     />

//                     {/* IFSC */}
//                     <Field
//                       label="IFSC"
//                       required
//                       name="senderIfsc"
//                       value={form.senderIfsc}
//                       onChange={handleChange}
//                       error={errors.senderIfsc}
//                       maxLength={11}
//                     />

//                     {/* ACCOUNT NUMBER + BANK VERIFICATION (same row) */}
//                     <div className="col-span-2">
//                       <label className="ds-label">
//                         A/C No{" "}
//                         <span className="text-[var(--error-color)]">*</span>
//                       </label>

//                       <div className="flex flex-col sm:flex-row sm:items-start gap-2">
//                         <div className="flex-1 min-w-0">
//                           <input
//                             type="text"
//                             name="senderAccount"
//                             value={form.senderAccount}
//                             onChange={handleChange}
//                             inputMode="numeric"
//                             maxLength={18}
//                             className={`ds-input min-w-0 w-full ${
//                               errors.senderAccount
//                                 ? "border-[var(--error-color)]"
//                                 : ""
//                             }`}
//                             placeholder="Enter account number"
//                           />
//                         </div>

//                         {/* Bank verification button / status */}
//                         <BankVerificationBox
//                           verification={bankVerification}
//                           className="shrink-0"
//                         />
//                       </div>

//                       {errors.senderAccount && (
//                         <p className="text-[var(--error-color)] text-sm mt-1">
//                           {errors.senderAccount}
//                         </p>
//                       )}

//                       {errors.bankVerification && !errors.senderAccount && (
//                         <p className="text-[var(--error-color)] text-sm mt-1">
//                           {errors.bankVerification}
//                         </p>
//                       )}
//                     </div>

//                     {/* PAN */}
//                     <Field
//                       label="PAN"
//                       required
//                       name="senderPanNumber"
//                       value={form.senderPanNumber}
//                       onChange={handleChange}
//                       error={errors.senderPanNumber}
//                       maxLength={10}
//                     />

//                     {/* ACCOUNT TYPE */}
//                     <Select
//                       label="Account Type"
//                       required
//                       name="senderAccType"
//                       value={form.senderAccType}
//                       onChange={handleChange}
//                       options={[
//                         { value: "SAVINGS", label: "SAVINGS" },
//                         { value: "CURRENT", label: "CURRENT" },
//                       ]}
//                       error={errors.senderAccType}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* CUSTOMER LOOKUP */}
//               <div>
//                 <CustomerLookup
//                   onSelect={fillBeneficiary}
//                   onNewCustomer={handleNewCustomer}
//                 />
//               </div>
//             </div>

//             <button
//               type="submit"
//               disabled={
//                 loading ||
//                 !pricingReady ||
//                 !bankVerificationReady ||
//                 bankVerificationPolicyLoading
//               }
//               className="ds-btn ds-btn-primary mt-2 mb-6"
//             >
//               {loading ? "Processing payout…" : "Generate Checkout"}
//             </button>

//             {/* TEMPORARY: Finkeda pricing breakdown for testing only.
//                 Remove/comment this section before production. */}
//             {/* <div className="mt-6">
//               <FinkedaPricingBreakdownBox
//                 amount={payoutPreview.amountEntered}
//                 pricing={pricing}
//                 loading={pricingLoading}
//                 error={pricingError}
//                 breakdown={{
//                   amount: payoutPreview.amountEntered,
//                   gatewayChargePercent: payoutPreview.gatewayChargePercent,
//                   gatewayChargeAmount: payoutPreview.gatewayChargeAmount,
//                   hierarchyPercent: payoutPreview.hierarchyPercent,
//                   hierarchyAmount: payoutPreview.hierarchyAmount,
//                   extraMarkup: payoutPreview.extraMarkup,
//                   extraMarkupAmount: payoutPreview.extraMarkupAmount,
//                   customerExtraPercent: payoutPreview.customerExtraPercent,
//                   customerExtraAmount: payoutPreview.customerExtraAmount,
//                   finalCustomerMarkup: payoutPreview.finalCustomerMarkup,
//                   finalCustomerMarkupAmount:
//                     payoutPreview.finalCustomerMarkupAmount,
//                   totalCharges: payoutPreview.totalCharges,
//                   customerWillReceive: payoutPreview.beneficiaryReceive,
//                   role: payoutPreview.role,
//                   planCode: payoutPreview.planCode,
//                 }}
//               />
//             </div> */}

//             {!pricingReady && !pricingLoading && (
//               <p className="text-[13px] text-[var(--error-color)] m-0">
//                 Payout submission is blocked until pricing loads successfully.
//               </p>
//             )}
//           </form>
//         </div>
//       </div>
//     </Main>
//   );
// };

// const Field = ({ label, error, required, ...props }) => (
//   <div>
//     <label className="ds-label">
//       {label}{" "}
//       {required && <span className="text-[var(--error-color)]">*</span>}
//     </label>

//     <input
//       {...props}
//       className={`ds-input ${error ? "border-[var(--error-color)]" : ""}`}
//     />

//     {error && (
//       <p className="text-[var(--error-color)] text-sm mt-1">{error}</p>
//     )}
//   </div>
// );

// const Select = ({ label, options, error, required, ...props }) => (
//   <div>
//     <label className="ds-label">
//       {label}{" "}
//       {required && <span className="text-[var(--error-color)]">*</span>}
//     </label>

//     <select
//       {...props}
//       className={`ds-input ${error ? "border-[var(--error-color)]" : ""}`}
//     >
//       {options.map((option) => (
//         <option key={option.value} value={option.value}>
//           {option.label}
//         </option>
//       ))}
//     </select>

//     {error && (
//       <p className="text-[var(--error-color)] text-sm mt-1">{error}</p>
//     )}
//   </div>
// );

// export default PgPayout;



import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";
import Main from "../Main";
import {
  createFinkedaCheckout,
  fetchFinkedaGateways,
  fetchFinkedaPayoutPricing,
} from "../../api/finkedaApi";
import { fetchActiveProviders } from "../../api/providerApi";
import { useNotify } from "../../context/NotifyContext";
import CustomerLookup from "../../components/CustomerLookup";
import useBankVerification from "../../hooks/useBankVerification";
import BankVerificationBox from "../../components/BankVerificationBox";

// TEMPORARY: Finkeda pricing breakdown for testing only.
// Remove/comment this section before production.
import FinkedaPricingBreakdownBox from "../../components/FinkedaPricingBreakdownBox";

const PAN_RE = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
const IFSC_RE = /^[A-Z]{4}0[A-Z0-9]{6}$/;

function round2(x) {
  return Math.round((Number(x) + Number.EPSILON) * 100) / 100;
}

const PgPayout = () => {
  const { notify } = useNotify();
  const navigate = useNavigate();
  const apiVersion = "v1";
  const [providerActive, setProviderActive] = useState(true);

  const submitLock = useRef(false);
  const nameInputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [gateways, setGateways] = useState([]);
  const [errors, setErrors] = useState({});

  const [pricing, setPricing] = useState(null);
  const [pricingLoading, setPricingLoading] = useState(true);
  const [pricingError, setPricingError] = useState("");

  const [form, setForm] = useState({
    amount: "",
    settledIn: "super",
    cardType: "CREDITCARD",
    cardNetwork: "MASTERCARD",
    pgType: "",
    markup: "", // total customer markup (same as before, goes to backend)
    binValue: "",

    senderName: "",
    senderAccount: "",
    senderIfsc: "",
    senderBank: "",
    senderMobile: "",
    senderPanNumber: "",
    senderAccType: "SAVINGS",
  });


  const [totalText, setTotalText] = useState("");
  const totalTouched = useRef(false);
  const totalTimer = useRef(null); // 3s debounce for minimum check

  useEffect(() => () => clearTimeout(totalTimer.current), []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await fetchActiveProviders("PG_PAYOUT");
      if (cancelled) return;
      const list = res.data?.providers || [];
      const active = list.some(
        (row) =>
          String(row.providerCode).toUpperCase() === "FINKEDA" &&
          String(row.providerVersion || "v1").toLowerCase() === apiVersion
      );
      setProviderActive(active);
      if (!active) {
        notify(
          `Finkeda ${apiVersion.toUpperCase()} is inactive. Choose an active provider.`,
          "error"
        );
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [apiVersion, notify]);

  const [isNewCustomer, setIsNewCustomer] = useState(false);
  const [customerSourceId, setCustomerSourceId] = useState("");

  const bankVerification = useBankVerification({
    accountNumber: form.senderAccount,
    ifsc: form.senderIfsc,
    name: form.senderName,
    bankId: form.senderBank,
    sourceType: "MATM",
    sourceId: customerSourceId,
    onVerified: (result) => {
      if (result.beneficiaryName) {
        setForm((current) => ({
          ...current,
          senderName: result.beneficiaryName,
        }));
      }
    },
  });

  const {
    result: currentBankVerification,
    ready: bankVerificationReady,
    policyLoading: bankVerificationPolicyLoading,
  } = bankVerification;

  useEffect(() => {
    (async () => {
      try {
        const res = await fetchFinkedaGateways();

        const list = Array.isArray(res?.data)
          ? res.data
          : res?.data?.gateways || [];

        setGateways(list);

        const firstGateway = list?.[0];
        const firstPg = firstGateway?.pgType || firstGateway?.code || "";
        const firstCt = firstGateway?.cardTypes?.[0] || "CREDITCARD";
        const firstDetail =
          firstGateway?.cardTypeDetails?.find((d) => d.cardType === firstCt) ||
          firstGateway?.cardTypeDetails?.[0];
        const firstNet = firstDetail?.networks?.[0] || "MASTERCARD";

        if (firstPg) {
          setForm((prev) => ({
            ...prev,
            pgType: prev.pgType || firstPg,
            cardType: prev.cardType || firstCt,
            cardNetwork: prev.cardNetwork || firstNet,
          }));
        }
      } catch {
        setGateways([]);
      }
    })();
  }, []);

  const selectedGateway = useMemo(() => {
    return (
      gateways.find(
        (g) =>
          (g.pgType || g.code) === form.pgType ||
          g.code === form.pgType
      ) ||
      gateways[0] ||
      null
    );
  }, [gateways, form.pgType]);

  const availableCardTypes = useMemo(() => {
    if (!selectedGateway?.cardTypes?.length) {
      return [{ value: "CREDITCARD", label: "CREDITCARD" }];
    }
    return selectedGateway.cardTypes.map((ct) => ({ value: ct, label: ct }));
  }, [selectedGateway]);

  const selectedCardTypeDetail = useMemo(() => {
    if (!selectedGateway?.cardTypeDetails?.length) return null;
    return (
      selectedGateway.cardTypeDetails.find(
        (d) => d.cardType === form.cardType
      ) ||
      selectedGateway.cardTypeDetails[0] ||
      null
    );
  }, [selectedGateway, form.cardType]);

  const availableCardNetworks = useMemo(() => {
    const list =
      selectedCardTypeDetail?.networks ||
      selectedGateway?.networks?.map((n) => n.networkType) || [
        "MASTERCARD",
        "VISACARD",
        "RUPAYCARD",
      ];
    const unique = [...new Set(list.filter(Boolean))];
    return unique.map((net) => ({ value: net, label: net }));
  }, [selectedCardTypeDetail, selectedGateway]);

  const amountLimits = useMemo(() => {
    const netLimit = selectedCardTypeDetail?.networkLimits?.[form.cardNetwork];
    const min = netLimit?.minAmount ?? selectedCardTypeDetail?.minAmount ?? 1;
    const max = netLimit?.maxAmount ?? selectedCardTypeDetail?.maxAmount ?? 50000;
    return { minAmount: Number(min) || 1, maxAmount: Number(max) || 50000 };
  }, [selectedCardTypeDetail, form.cardNetwork]);

  useEffect(() => {
    const timer = setTimeout(async () => {
      try {
        setPricingLoading(true);
        setPricingError("");

        const res = await fetchFinkedaPayoutPricing({
          amount: form.amount || 0,
          pgType: form.pgType || undefined,
          cardType: form.cardType || undefined,
          cardNetwork: form.cardNetwork || undefined,
        });

        if (!res.success || !res.data) {
          setPricing(null);
          setPricingError(
            res.message ||
              "Unable to load pricing. Payout is blocked."
          );
          return;
        }

        const data = res.data;

        if (
          data.customerMarkup == null &&
          data.pricing?.customerMarkup == null
        ) {
          setPricing(null);
          setPricingError(
            "Incomplete pricing received. Payout is blocked."
          );
          return;
        }

        const minMarkup = Number(
          data.customerMarkup ?? data.pricing?.customerMarkup ?? 0
        );
        setPricing(data);

        setForm((prev) => {
          const currentMarkupNum = Number(prev.markup);
          const needsDefault =
            prev.markup === "" ||
            prev.markup === "0" ||
            !Number.isFinite(currentMarkupNum) ||
            currentMarkupNum < minMarkup;
          return {
            ...prev,
            markup: needsDefault ? String(minMarkup) : prev.markup,
          };
        });
      } catch {
        setPricing(null);
        setPricingError(
          "Unable to load pricing. Payout is blocked."
        );
      } finally {
        setPricingLoading(false);
      }
    }, 250);

    return () => clearTimeout(timer);
  }, [form.pgType, form.cardType, form.cardNetwork, form.amount]);

  /*
   * UI only: pricing badalne par (pgType / cardType / network / amount)
   * total ko sync rakhta hai aur form.markup = total - gateway set karta hai.
   * Agar user ne total nahi chheda to total = gateway + customerMarkup (minimum).
   */
  useEffect(() => {
    if (!pricing) return;
    const gateway = Number(
      pricing?.gatewayChargePercent ??
        pricing?.pricing?.gatewayChargePercent ??
        0
    );
    const min = Number(
      pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
    );
    const base = round2(gateway + min);
    const typed = Number(totalText);

    const total =
      !totalTouched.current || !Number.isFinite(typed) || typed < base
        ? base
        : Math.min(typed, 100);

    if (String(total) !== totalText) setTotalText(String(total));
    setForm((prev) => ({
      ...prev,
      markup: String(round2(total - gateway)),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pricing]);

  /*
   * Payout preview calculation:
   * Total Charges = PG charge + customer markup + flat payout charge (₹)
   * Beneficiary Receive = amount - Total Charges
   * Performer Earning = Extra markup charged above minimum customer markup
   */
  const payoutPreview = useMemo(() => {
    const amount = Number(form.amount) || 0;
    const enteredMarkup = Number(form.markup) || 0;

    const gatewayChargePercent = Number(
      pricing?.gatewayChargePercent ??
        pricing?.pricing?.gatewayChargePercent ??
        0
    );
    const hierarchyPercent = Number(
      pricing?.hierarchyPercent ??
        pricing?.pricing?.hierarchyPercent ??
        0
    );
    const extraMarkup = Number(
      pricing?.extraMarkup ??
        pricing?.pricing?.extraMarkup ??
        0
    );
    const customerMarkup = Number(
      pricing?.customerMarkup ??
        pricing?.pricing?.customerMarkup ??
        round2(hierarchyPercent + extraMarkup)
    );

    const actualMarkup = Math.max(enteredMarkup, customerMarkup);
    const finalCustomerMarkup = actualMarkup;

    const customerExtraPercent = round2(
      Math.max(0, actualMarkup - customerMarkup)
    );

    // Flat payout charge in ₹ (PayoutPricing slab / ₹15 fallback) from backend
    const payoutCharge = round2(Number(pricing?.payoutCharge ?? 0));

    // Charge & Markup Amounts based on backend pricing
    const gatewayChargeAmount = round2((amount * gatewayChargePercent) / 100);
    const hierarchyAmount = round2((amount * hierarchyPercent) / 100);
    const extraMarkupAmount = round2((amount * extraMarkup) / 100);
    const customerExtraAmount = round2((amount * customerExtraPercent) / 100);
    const finalCustomerMarkupAmount = round2((amount * finalCustomerMarkup) / 100);
    const totalCharges = round2(
      gatewayChargeAmount + finalCustomerMarkupAmount + payoutCharge
    );
    const totalChargesPercent = round2(gatewayChargePercent + finalCustomerMarkup);
    const customerCharge = totalCharges;
    const beneficiaryReceive = round2(Math.max(0, amount - totalCharges));
    const walletEarning = customerExtraAmount;

    return {
      amountEntered: round2(amount),
      customerMarkup,
      actualMarkup,
      gatewayChargePercent,
      gatewayChargeAmount,
      hierarchyPercent,
      hierarchyAmount,
      extraMarkup,
      extraMarkupAmount,
      customerExtraPercent,
      customerExtraAmount,
      finalCustomerMarkup,
      finalCustomerMarkupAmount,
      payoutCharge,
      totalCharges,
      totalChargesPercent,
      customerCharge,
      beneficiaryReceive,
      walletEarning,
      role:
        pricing?.performerRole ||
        pricing?.pricing?.performerRole ||
        "retailer",
      planCode:
        pricing?.planCode ||
        pricing?.pricing?.planCode ||
        "",
    };
  }, [form.amount, form.markup, pricing]);

  const pricingReady = Boolean(
    pricing &&
      (pricing.customerMarkup != null ||
        pricing.pricing?.customerMarkup != null)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (
      [
        "senderName",
        "senderAccount",
        "senderIfsc",
        "senderBank",
        "senderMobile",
        "senderPanNumber",
        "senderAccType",
      ].includes(name)
    ) {
      setCustomerSourceId("");
    }

    let next = value;

    if (
      ["amount", "senderAccount", "senderMobile", "binValue"].includes(name)
    ) {
      next = value.replace(/\D/g, "");
    }

    if (name === "amount" && Number(next) > amountLimits.maxAmount) {
      next = String(amountLimits.maxAmount);
    }

    if (name === "binValue") {
      next = next.slice(0, 6);
    }

    if (name === "senderMobile") {
      next = next.slice(0, 10);
    }

    if (name === "senderAccount") {
      next = next.slice(0, 18);
    }

    if (name === "senderIfsc" || name === "senderPanNumber") {
      next = value.toUpperCase().replace(/\s/g, "");
    }

    if (name === "markup") {
      next = value.replace(/[^\d.]/g, "");

      const parts = next.split(".");

      if (parts.length > 2) {
        next = `${parts[0]}.${parts.slice(1).join("")}`;
      }

      if (Number(next) > 100) {
        next = "100";
      }

      /*
       * Never allow markup below minimum.
       */
      const minMarkup = Number(
        pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
      );
      if (
        next !== "" &&
        pricing &&
        Number.isFinite(minMarkup) &&
        Number(next) < minMarkup
      ) {
        next = String(minMarkup);
      }
    }

    if (name === "pgType") {
      const g = gateways.find((item) => (item.pgType || item.code) === next);
      const nextCardType = g?.cardTypes?.[0] || "CREDITCARD";
      const ctDetail =
        g?.cardTypeDetails?.find((d) => d.cardType === nextCardType) ||
        g?.cardTypeDetails?.[0];
      const nextNetwork = ctDetail?.networks?.[0] || "MASTERCARD";
      setForm((prev) => ({
        ...prev,
        pgType: next,
        cardType: nextCardType,
        cardNetwork: nextNetwork,
      }));
      if (errors.pgType) setErrors((prev) => ({ ...prev, pgType: "" }));
      return;
    }

    if (name === "cardType") {
      const g = gateways.find(
        (item) => (item.pgType || item.code) === form.pgType
      );
      const ctDetail =
        g?.cardTypeDetails?.find((d) => d.cardType === next) ||
        g?.cardTypeDetails?.[0];
      const currentNetworkValid = ctDetail?.networks?.includes(form.cardNetwork);
      const nextNetwork = currentNetworkValid
        ? form.cardNetwork
        : ctDetail?.networks?.[0] || "MASTERCARD";
      setForm((prev) => ({
        ...prev,
        cardType: next,
        cardNetwork: nextNetwork,
      }));
      if (errors.cardType) setErrors((prev) => ({ ...prev, cardType: "" }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: next,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    // account / IFSC / name badalne par purana bank-verification error hata do
    if (
      ["senderAccount", "senderIfsc", "senderName", "senderBank"].includes(
        name
      ) &&
      errors.bankVerification
    ) {
      setErrors((prev) => ({ ...prev, bankVerification: "" }));
    }
  };

  /*
   * UI only: user TOTAL % type karta hai (e.g. 3).
   * Total - PG charge = customer markup (customerMarkup + extra).
   * form.markup = total - gateway  (backend ko wahi customer markup jata hai).
   */
  const handleTotalChange = (e) => {
    let v = e.target.value.replace(/[^\d.]/g, "");

    const parts = v.split(".");
    if (parts.length > 2) v = `${parts[0]}.${parts.slice(1).join("")}`;

    const [i, d] = v.split(".");
    if (d !== undefined) v = `${i}.${d.slice(0, 2)}`;

    if (Number(v) > 100) v = "100";

    const gateway = Number(
      pricing?.gatewayChargePercent ??
        pricing?.pricing?.gatewayChargePercent ??
        0
    );
    const min = Number(
      pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
    );
    const base = round2(gateway + min);

    // Typing ke time har value allowed hai.
    totalTouched.current = v !== "";
    setTotalText(v);

    // 3 second typing band hone ke baad check: kam ho to minimum dikhao,
    // zyada ho to kuch nahi karna.
    clearTimeout(totalTimer.current);
    totalTimer.current = setTimeout(() => {
      setTotalText((prev) => {
        const n = Number(prev);
        if (prev === "" || !Number.isFinite(n) || n < base) {
          totalTouched.current = false;
          return String(base);
        }
        return prev;
      });
    }, 3000);

    const total = Math.max(Number(v) || 0, base);
    setForm((prev) => ({
      ...prev,
      markup: String(round2(total - gateway)),
    }));

    if (errors.markup) setErrors((prev) => ({ ...prev, markup: "" }));
  };

  // Field se bahar jaate hi bhi same check (3s ka wait nahi).
  const handleTotalBlur = () => {
    const gateway = Number(
      pricing?.gatewayChargePercent ??
        pricing?.pricing?.gatewayChargePercent ??
        0
    );
    const min = Number(
      pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
    );
    const base = round2(gateway + min);
    const typed = Number(totalText);

    clearTimeout(totalTimer.current);
    if (totalText === "" || !Number.isFinite(typed) || typed < base) {
      totalTouched.current = false;
      setTotalText(String(base));
    }
  };

  const validate = () => {
    const next = {};

    const amount = Number(form.amount);

    if (!Number.isInteger(amount) || amount <= 0) {
      next.amount = "Amount must be a positive whole number";
    } else if (amount < amountLimits.minAmount) {
      next.amount = `Minimum amount allowed is ₹${amountLimits.minAmount}`;
    } else if (amount > amountLimits.maxAmount) {
      next.amount = `Maximum amount allowed is ₹${amountLimits.maxAmount.toLocaleString("en-IN")}`;
    }

    if (!next.amount && payoutPreview.beneficiaryReceive <= 0) {
      next.amount = "Amount too low to cover charges";
    }

    if (!["super", "counter"].includes(form.settledIn)) {
      next.settledIn = "settledIn must be super or counter";
    }

    if (!form.cardType) {
      next.cardType = "Card type is required";
    }

    if (!form.cardNetwork) {
      next.cardNetwork = "Card network is required";
    }

    if (!form.pgType) {
      next.pgType = "Select a gateway type";
    }

    if (!pricingReady) {
      next.markup = "Pricing must load successfully before payout";
    } else {
      const markup = Number(form.markup);
      const minimumMarkup = Number(
        pricing?.customerMarkup ?? pricing?.pricing?.customerMarkup ?? 0
      );

      if (
        form.markup === "" ||
        !Number.isFinite(markup) ||
        markup < minimumMarkup ||
        markup > 100
      ) {
        next.markup = `Customer markup must be at least ${minimumMarkup}% and at most 100%`;
      }

      const gatewayPct = Number(
        pricing?.gatewayChargePercent ??
          pricing?.pricing?.gatewayChargePercent ??
          0
      );
      if (!next.markup && Number(totalText) < round2(gatewayPct + minimumMarkup)) {
        next.markup = `Total must be at least ${round2(gatewayPct + minimumMarkup)}%`;
      }
      if (!next.markup && gatewayPct + markup > 100) {
        next.markup = "Total charges (PG + markup) cannot exceed 100%";
      }
    }

    if (form.binValue && form.binValue.length !== 6) {
      next.binValue = "BIN must be first 6 digits of the card";
    }

    if (!form.senderName || form.senderName.trim().length < 3) {
      next.senderName = "Name as per bank records is required";
    }

    if (!/^\d{8,18}$/.test(form.senderAccount)) {
      next.senderAccount = "Account number must be 8–18 digits";
    }

    if (!IFSC_RE.test(form.senderIfsc)) {
      next.senderIfsc = "Invalid IFSC";
    }

    if (!form.senderBank.trim()) {
      next.senderBank = "Bank name is required";
    }

    if (!bankVerificationReady) {
      next.bankVerification =
        currentBankVerification?.message ||
        "Verify the bank account before generating checkout";
    }

    if (!/^[6-9]\d{9}$/.test(form.senderMobile)) {
      next.senderMobile = "Enter a valid 10-digit mobile";
    }

    if (!PAN_RE.test(form.senderPanNumber)) {
      next.senderPanNumber = "Enter a valid PAN";
    }

    if (!["SAVINGS", "CURRENT"].includes(form.senderAccType)) {
      next.senderAccType = "Account type must be SAVINGS or CURRENT";
    }

    return next;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitLock.current || loading) {
      return;
    }

    const next = validate();

    if (Object.keys(next).length) {
      setErrors(next);

      notify(
        Object.values(next)[0] || "Please fix the errors in the form.",
        "error"
      );

      return;
    }

    try {
      submitLock.current = true;
      setLoading(true);
      if (!providerActive) {
        notify(`Finkeda ${apiVersion.toUpperCase()} is inactive`, "error");
        return;
      }

      const payload = {
        purpose: "PAYOUT",
        amount: Number(form.amount),

        settledIn: form.settledIn,
        cardType: form.cardType,
        cardNetwork: form.cardNetwork,
        pgType: form.pgType,

        markup: String(form.markup),

        binValue: form.binValue || undefined,

        name: form.senderName.trim(),
        mobile: form.senderMobile,

        idempotencyKey: `po_${Date.now()}_${Math.random()
          .toString(36)
          .slice(2, 10)}`.slice(0, 64),

        sender: {
          sourceType: "MATM",
          sourceId: customerSourceId,
          senderName: form.senderName.trim(),
          senderAccount: form.senderAccount,
          senderIfsc: form.senderIfsc,
          senderBank: form.senderBank.trim(),
          senderMobile: form.senderMobile,
          senderPanNumber: form.senderPanNumber,
          senderAccType: form.senderAccType,
        },
      };

      const result = await createFinkedaCheckout(payload);

      if (!result.success) {
        notify(result.message || "Payout failed", "error");
        return;
      }

      if (result.walletWarning) {
        notify(result.walletWarning, "warning");
      }

      if (result.requiresKyc && result.kycUrl) {
        notify(
          "First-time PAN: complete KYC, then retry this payout.",
          "success"
        );

        window.location.href = result.kycUrl;

        return;
      }

      if (result.redirectionUrl) {
        notify("Opening PG checkout…", "success");

        window.open(result.redirectionUrl, "_blank", "noopener,noreferrer");

        return;
      }

      notify(result.message || "Checkout created", "success");
    } catch {
      notify("Payout failed", "error");
    } finally {
      submitLock.current = false;
      setLoading(false);
    }
  };

  const fillBeneficiary = (customer) => {
    setIsNewCustomer(false);
    setCustomerSourceId(String(customer.id || customer._id || ""));

    setForm((prev) => ({
      ...prev,
      senderName: customer.name || prev.senderName,
      senderAccount: customer.accountNumber || prev.senderAccount,
      senderIfsc: customer.ifsc || prev.senderIfsc,
      senderBank: customer.bank || prev.senderBank,
      senderMobile: customer.mobile || prev.senderMobile,
      senderPanNumber: customer.pan || prev.senderPanNumber,
      senderAccType: customer.accType || prev.senderAccType,
    }));

    setErrors((prev) => ({
      ...prev,
      senderName: "",
      senderAccount: "",
      senderIfsc: "",
      senderBank: "",
      senderMobile: "",
      senderPanNumber: "",
      senderAccType: "",
      bankVerification: "",
    }));
  };

  const handleNewCustomer = () => {
    setIsNewCustomer(true);
    setCustomerSourceId("");

    setForm((prev) => ({
      ...prev,
      senderName: "",
      senderAccount: "",
      senderIfsc: "",
      senderBank: "",
      senderMobile: "",
      senderPanNumber: "",
      senderAccType: "SAVINGS",
    }));

    setErrors((prev) => ({
      ...prev,
      senderName: "",
      senderAccount: "",
      senderIfsc: "",
      senderBank: "",
      senderMobile: "",
      senderPanNumber: "",
      senderAccType: "",
      bankVerification: "",
    }));

    setTimeout(() => {
      nameInputRef.current?.focus();
    }, 100);
  };

  // UI only: derived values for "Total - (PG + Hierarchy) = Extra"
  const baseTotal = round2(
    payoutPreview.gatewayChargePercent + payoutPreview.customerMarkup
  );
  const totalShown = Math.max(Number(totalText) || 0, baseTotal);
  const extraShown = round2(Math.max(0, totalShown - baseTotal));

  return (
    <Main showRightPanel={false}>
      <div className="flex flex-col">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "MATM Module" },
            { label: "PG + Payout", to: "/pg-payout" },
            { label: `Finkeda ${apiVersion.toUpperCase()}` },
          ]}
        />

        <div className="w-full max-w-6xl mb-4 mt-4">
          <h2 className="text-[15px] sm:text-lg font-semibold text-[var(--text-dark)] mb-3">
            PG + Payout · Finkeda {apiVersion.toUpperCase()}
          </h2>
          {!providerActive && (
            <p className="text-sm text-[var(--error-color)]">
              This version is inactive.{" "}
              <button type="button" className="underline" onClick={() => navigate("/pg-payout")}>
                Choose another provider
              </button>
            </p>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {/* LEFT SIDE */}
              <div className="space-y-4">
                {/* CARD DETAILS */}
                <div className="ds-card p-4 sm:p-5">
                  <h3 className="text-[14px] font-semibold mb-3">
                    Card / Payment Details
                  </h3>

                  <div className="grid grid-cols-2 gap-4">
                    {/* AMOUNT */}
                    <div>
                      <Field
                        label="Amount"
                        required
                        name="amount"
                        value={form.amount}
                        onChange={handleChange}
                        error={errors.amount}
                        inputMode="numeric"
                      />
                      <p className="text-[11px] text-[var(--text-muted)] mt-1 font-medium">
                        Allowed limit: Min ₹{amountLimits.minAmount} — Max ₹
                        {amountLimits.maxAmount.toLocaleString("en-IN")}
                      </p>
                    </div>

                    {/* RECEIVED AMOUNT */}
                    <div>
                      <label className="ds-label">Received Amount</label>

                      <input
                        type="text"
                        value={`₹${payoutPreview.beneficiaryReceive.toFixed(2)}`}
                        disabled
                        readOnly
                        className="ds-input bg-[var(--surface)] opacity-80 cursor-not-allowed"
                      />

                      <p className="text-[11px] text-[var(--text-muted)] mt-1">
                        Beneficiary receives (after payout charge ₹
                        {payoutPreview.payoutCharge.toFixed(2)})
                      </p>
                    </div>

                    {/* SETTLEMENT */}
                    <Select
                      label="settledIn"
                      required
                      name="settledIn"
                      value={form.settledIn}
                      onChange={handleChange}
                      options={[
                        { value: "super", label: "super — Super Merchant" },
                        { value: "counter", label: "counter — Sub Merchant" },
                      ]}
                      error={errors.settledIn}
                    />

                    {/* CARD TYPE */}
                    <Select
                      label="Card Type"
                      required
                      name="cardType"
                      value={form.cardType}
                      onChange={handleChange}
                      options={availableCardTypes}
                      error={errors.cardType}
                    />

                    {/* CARD NETWORK */}
                    <Select
                      label="Card Network"
                      required
                      name="cardNetwork"
                      value={form.cardNetwork}
                      onChange={handleChange}
                      options={availableCardNetworks}
                      error={errors.cardNetwork}
                    />

                    {/* GATEWAY */}
                    <div>
                      <label className="ds-label">
                        pgType{" "}
                        <span className="text-[var(--error-color)]">*</span>
                      </label>

                      <select
                        name="pgType"
                        value={form.pgType}
                        onChange={handleChange}
                        className={`ds-input ${
                          errors.pgType ? "border-[var(--error-color)]" : ""
                        }`}
                      >
                        {!gateways.length && (
                          <option value="">Loading gateways from DB…</option>
                        )}

                        {gateways.map((gateway, index) => {
                          const value =
                            gateway.pgType ||
                            gateway.code ||
                            gateway.name ||
                            String(gateway);

                          return (
                            <option key={`${value}-${index}`} value={value}>
                              {gateway.name || gateway.code || value}
                            </option>
                          );
                        })}
                      </select>

                      {errors.pgType && (
                        <p className="text-[var(--error-color)] text-sm mt-1">
                          {errors.pgType}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* APPLICABLE PRICING & CHARGES */}
                  <div className="mt-4 border border-[var(--border-color)] rounded-xl p-2 sm:p-2 bg-[var(--surface)] shadow-sm space-y-4">
                    <p className="text-[13px] font-semibold m-0">
                      Applicable Pricing & Charges
                    </p>

                    {pricingLoading ? (
                      <p className="text-[13px] text-[var(--text-muted)] m-0">
                        Loading pricing…
                      </p>
                    ) : pricingError ? (
                      <p className="text-[13px] text-[var(--error-color)] m-0">
                        {pricingError}
                      </p>
                    ) : (
                      <>
                        {/* MARKUP: TOTAL (user types) - PG - PAYOUT = EXTRA */}
                        <div className="mt-3">
                          <label className="ds-label">
                            Customer Markup %{" "}
                            <span className="text-[var(--error-color)]">*</span>
                          </label>

                          <div className="flex sm:flex-nowrap items-start gap-1">
                            {/* TOTAL: user enters here */}
                            <div className="flex-1 min-w-[60px]">
                              <input
                                type="text"
                                value={totalText}
                                onChange={handleTotalChange}
                                onBlur={handleTotalBlur}
                                placeholder="Total %"
                                inputMode="decimal"
                                className={`ds-input ${
                                  errors.markup
                                    ? "border-[var(--error-color)]"
                                    : ""
                                }`}
                              />
                              <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
                                Total
                              </p>
                            </div>

                            <span className="pt-2 font-bold text-[16px]">-</span>

                            {/* PG + HIERARCHY (locked) */}
                            <div className="flex-1 min-w-[55px]">
                              <input
                                type="text"
                                value={`${baseTotal}%`}
                                disabled
                                readOnly
                                className="ds-input bg-[var(--surface)] opacity-80 cursor-not-allowed"
                              />
                              <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
                                PG
                              </p>
                            </div>

                            <span className="pt-2 font-bold text-[16px]">-</span>

                            {/* PAYOUT CHARGE (flat ₹, locked) */}
                            <div className="flex-1 min-w-[55px]">
                              <input
                                type="text"
                                value={`₹${payoutPreview.payoutCharge}`}
                                disabled
                                readOnly
                                className="ds-input bg-[var(--surface)] opacity-80 cursor-not-allowed"
                              />
                              <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
                                Payout
                              </p>
                            </div>

                            <span className="pt-2 font-bold text-[16px]">=</span>

                            {/* EXTRA = Total - (PG + Hierarchy) (auto) */}
                            <div className="flex-1 min-w-[60px]">
                              <input
                                type="text"
                                value={`${extraShown}%`}
                                disabled
                                readOnly
                                className="ds-input bg-[var(--surface)] font-semibold cursor-not-allowed"
                              />
                              <p className="text-[10px] text-[var(--text-muted)] mt-1 mb-0">
                                Extra
                              </p>
                            </div>
                          </div>

                          {errors.markup && (
                            <p className="text-[var(--error-color)] text-sm mt-1">
                              {errors.markup}
                            </p>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* BENEFICIARY DETAILS */}
                <div className="ds-card p-4 sm:p-5">
                  <h3 className="text-[14px] font-semibold mb-3">
                    Beneficiary Details
                  </h3>

                  <div className="grid grid-cols-2 gap-4">
                    {/* NAME */}
                    <div>
                      <label className="ds-label">
                        Name{" "}
                        <span className="text-[var(--error-color)]">*</span>
                      </label>

                      <input
                        ref={nameInputRef}
                        type="text"
                        name="senderName"
                        value={form.senderName}
                        onChange={handleChange}
                        className={`ds-input ${
                          errors.senderName ? "border-[var(--error-color)]" : ""
                        }`}
                        autoComplete="off"
                      />

                      {errors.senderName && (
                        <p className="text-[var(--error-color)] text-sm mt-1">
                          {errors.senderName}
                        </p>
                      )}
                    </div>

                    {/* MOBILE */}
                    <Field
                      label="Mobile"
                      required
                      name="senderMobile"
                      value={form.senderMobile}
                      onChange={handleChange}
                      error={errors.senderMobile}
                      maxLength={10}
                      inputMode="numeric"
                    />

                    {/* BANK */}
                    <Field
                      label="Bank"
                      required
                      name="senderBank"
                      value={form.senderBank}
                      onChange={handleChange}
                      error={errors.senderBank}
                    />

                    {/* IFSC */}
                    <Field
                      label="IFSC"
                      required
                      name="senderIfsc"
                      value={form.senderIfsc}
                      onChange={handleChange}
                      error={errors.senderIfsc}
                      maxLength={11}
                    />

                    {/* ACCOUNT NUMBER + BANK VERIFICATION (same row) */}
                    <div className="col-span-2">
                      <label className="ds-label">
                        A/C No{" "}
                        <span className="text-[var(--error-color)]">*</span>
                      </label>

                      <div className="flex flex-col sm:flex-row sm:items-start gap-2">
                        <div className="flex-1 min-w-0">
                          <input
                            type="text"
                            name="senderAccount"
                            value={form.senderAccount}
                            onChange={handleChange}
                            inputMode="numeric"
                            maxLength={18}
                            className={`ds-input min-w-0 w-full ${
                              errors.senderAccount
                                ? "border-[var(--error-color)]"
                                : ""
                            }`}
                            placeholder="Enter account number"
                          />
                        </div>

                        {/* Bank verification button / status */}
                        <BankVerificationBox
                          verification={bankVerification}
                          className="shrink-0"
                        />
                      </div>

                      {errors.senderAccount && (
                        <p className="text-[var(--error-color)] text-sm mt-1">
                          {errors.senderAccount}
                        </p>
                      )}

                      {errors.bankVerification && !errors.senderAccount && (
                        <p className="text-[var(--error-color)] text-sm mt-1">
                          {errors.bankVerification}
                        </p>
                      )}
                    </div>

                    {/* PAN */}
                    <Field
                      label="PAN"
                      required
                      name="senderPanNumber"
                      value={form.senderPanNumber}
                      onChange={handleChange}
                      error={errors.senderPanNumber}
                      maxLength={10}
                    />

                    {/* ACCOUNT TYPE */}
                    <Select
                      label="Account Type"
                      required
                      name="senderAccType"
                      value={form.senderAccType}
                      onChange={handleChange}
                      options={[
                        { value: "SAVINGS", label: "SAVINGS" },
                        { value: "CURRENT", label: "CURRENT" },
                      ]}
                      error={errors.senderAccType}
                    />
                  </div>
                </div>
              </div>

              {/* CUSTOMER LOOKUP */}
              <div>
                <CustomerLookup
                  onSelect={fillBeneficiary}
                  onNewCustomer={handleNewCustomer}
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={
                loading ||
                !providerActive ||
                !pricingReady ||
                !bankVerificationReady ||
                bankVerificationPolicyLoading
              }
              className="ds-btn ds-btn-primary mt-2 mb-6"
            >
              {loading ? "Processing payout…" : `Generate Checkout (${apiVersion.toUpperCase()})`}
            </button>

            {/* TEMPORARY: Finkeda pricing breakdown for testing only.
                Remove/comment this section before production. */}
            {/* <div className="mt-6">
              <FinkedaPricingBreakdownBox
                amount={payoutPreview.amountEntered}
                pricing={pricing}
                loading={pricingLoading}
                error={pricingError}
                breakdown={{
                  amount: payoutPreview.amountEntered,
                  gatewayChargePercent: payoutPreview.gatewayChargePercent,
                  gatewayChargeAmount: payoutPreview.gatewayChargeAmount,
                  hierarchyPercent: payoutPreview.hierarchyPercent,
                  hierarchyAmount: payoutPreview.hierarchyAmount,
                  extraMarkup: payoutPreview.extraMarkup,
                  extraMarkupAmount: payoutPreview.extraMarkupAmount,
                  customerExtraPercent: payoutPreview.customerExtraPercent,
                  customerExtraAmount: payoutPreview.customerExtraAmount,
                  finalCustomerMarkup: payoutPreview.finalCustomerMarkup,
                  finalCustomerMarkupAmount:
                    payoutPreview.finalCustomerMarkupAmount,
                  payoutCharge: payoutPreview.payoutCharge,
                  totalCharges: payoutPreview.totalCharges,
                  customerWillReceive: payoutPreview.beneficiaryReceive,
                  role: payoutPreview.role,
                  planCode: payoutPreview.planCode,
                }}
              />
            </div> */}

            {!pricingReady && !pricingLoading && (
              <p className="text-[13px] text-[var(--error-color)] m-0">
                Payout submission is blocked until pricing loads successfully.
              </p>
            )}
          </form>
        </div>
      </div>
    </Main>
  );
};

const Field = ({ label, error, required, ...props }) => (
  <div>
    <label className="ds-label">
      {label}{" "}
      {required && <span className="text-[var(--error-color)]">*</span>}
    </label>

    <input
      {...props}
      className={`ds-input ${error ? "border-[var(--error-color)]" : ""}`}
    />

    {error && (
      <p className="text-[var(--error-color)] text-sm mt-1">{error}</p>
    )}
  </div>
);

const Select = ({ label, options, error, required, ...props }) => (
  <div>
    <label className="ds-label">
      {label}{" "}
      {required && <span className="text-[var(--error-color)]">*</span>}
    </label>

    <select
      {...props}
      className={`ds-input ${error ? "border-[var(--error-color)]" : ""}`}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    {error && (
      <p className="text-[var(--error-color)] text-sm mt-1">{error}</p>
    )}
  </div>
);

export default PgPayout;